const easy_answer = [
  {
    variable_id: "technology_1",
    element_id: "technology",
    variable_name: "Technology planning",
    question: "Which of the following technology planning statement best fit your organisation?",
    response: "There are carefully thought out plans in place to ensure the  adoption of emerging digital technologies within our organisation",
    options: [
      "Our organisation continues to improve on its techgnology planning and signifcant outcomes are being derived through the used of well planned digital technology adoption.",
      "Our organisation is still sceptical about the outcomes of adopting digital technologies",
      "The plan to digitally transform our organisation's business function using emerging digital technologies is at the infancy stage",
      "Our organisation understands the requirement needed for digitalisation of our business function and effort have been made to ensure all resources needed are available",
      "There are carefully thought out plans in place to ensure the  adoption of emerging digital technologies within our organisation",
    ],
  },
  {
    variable_id: "technology_2",
    element_id: "technology",
    variable_name: "Optimisation of Emerging technologies e.g BIM",
    question:
      "Please select the statement that is most applicable to your organisation in respect to the extent of adoption and optimisation of emerging digital technologies.",
    response: "Very few digital technologies are adopted  for the sole purpose of easing our day-to-day organisational functions.",
    options: [
      "We have set quantifiable goals for digital transofrmation of the organisation, and significant improvement in construction productivity is being made through the use of digital technologies. ",
      "My organisation understand the need to  adopt emerging digital technologies  and plans towards adopting them to digitalise the organisation's services.",
      "My organisation is in a learning phase and as such only few digital technologies are adopted with the intent of digitising  organisational functions.",
      "My organisation is a digital disruptor and it leads the construction industry discussion on digital transformation.",
      "Very few digital technologies are adopted  for the sole purpose of easing our day-to-day organisational functions.",
    ],
  },
  {
    variable_id: "technology_3",
    element_id: "technology",
    variable_name: "Big data analytics",
    question: "Please select the statement that is most applicable to your organisation in respect to big data analytics.",
    response: "Our organisation has no defined data analystics system ",
    options: [
      "Our organisation's decision-making is largely data-driven. ",
      "Our organisation understands the need to analyse data from past projects, but do not have the capability to correctly mine and analyse the data",
      "Our organisation have the digital technologies needed to mine and analyse data.",
      "In our organisation, there is a continuous improvement in data analytics ",
      "Our organisation has no defined data analystics system ",
    ],
  },
  {
    variable_id: "technology_4",
    element_id: "technology",
    variable_name: "Additive manufacturing (3D Printing)",
    question: "Please select the statement that is most applicable to your organisation in respect to the use of additive manufacturing.",
    response:
      "Our organisation understands the importance of 3D printing in construction. Clear policy regarding the adoption of this technology are already in place.",
    options: [
      "Presently, our organisation lacks the capability to adopt 3D printing and we are sceptical about the inherent benefits",
      "Our organisation has been able to optimise the use of 3D printing in our delivery of construction projects.",
      "Our organisation's prioritises the use of 3D printing in delivering more efficient construction projects.",
      "Our organisation understands the importance of 3D printing in construction and we are willing to learn from repeated adoption. However, we are challenged by limited resources",
      "Our organisation understands the importance of 3D printing in construction. Clear policy regarding the adoption of this technology are already in place.",
    ],
  },
  {
    variable_id: "technology_5",
    element_id: "technology",
    variable_name: "Cloud computing/Connected things ",
    question: "Please select the statement that is most applicable to your organisation in respect to the use of cloud computing.",
    response: "In our organisation, there is a continuous improvement in the use of cloud computing ",
    options: [
      "Our organisation has no defined data storage system and the use of internet is majorly of small office functions ",
      "Our organisation use technology such as computers and hardrives to store data and assess to any form of computing must be done within the organisation",
      "In our organisation, computing resoruces and data storage are centralised and easily shared for faster and more effeicent information exchange in improved productivity. ",
      "Our data storage and computing process is done over the internet ('the cloud')",
      "In our organisation, there is a continuous improvement in the use of cloud computing ",
    ],
  },
  {
    variable_id: "technology_6",
    element_id: "technology",
    variable_name: "Design simulation and visualisation",
    question: "Please select the statement that is most applicable to your organisation in respect to the use of design simulation and visualisation tools.",
    response: "Presently, the adoption of simulation and visualisation tools is at the early planning stage in our organisation",
    options: [
      "Our organisation understands the importance of design simulation and visualisation and we are willing to learn from repeated adoption. However, we are challenged by limited resources",
      "Our organisation has been able to optimise the use of design simulation and visualisation tools in our  delivery of quality services to our clients. ",
      "Our organisation prioritises the use of design simulation and visualisation tools in creating a better experience for our clients",
      "Our organisation understands the importance of design simulation and visualisation. Clear policy regarding the adoption of related technologies are already in place.",
      "Presently, the adoption of simulation and visualisation tools is at the early planning stage in our organisation",
    ],
  },
  {
    variable_id: "technology_7",
    element_id: "technology",
    variable_name: "Robotics and automation in construction",
    question: "Please select the statement that is most applicable to your organisation in respect to the use of robotics and automation.",
    response: "Our organisation has been able to optimise the use of robotics and automation in our  delivery of construction projects. ",
    options: [
      "Currently, our organisation lacks the capability to adopt robotics and automation and we are sceptical about the inherent benefits",
      "Our organisation understands the importance of robotics and automation in construction. Clear policy regarding the adoption of this technology are already in place.",
      "Our organisation's prioritises the use of robotics and automation in delivering more efficient construction projects.",
      "Our organisation understands the importance of robotics and automation in construction and we are willing to learn from repeated adoption. However, we are challenged by limited resources",
      "Our organisation has been able to optimise the use of robotics and automation in our  delivery of construction projects. ",
    ],
  },
  {
    variable_id: "technology_8",
    element_id: "technology",
    variable_name: "Cybersecurity",
    question: "Which of the following cybersecurity statement best fit your organisation?",
    response:
      "Our organisation knows the importance of data and information protection and has plans towards ensuring up-to-date cybersecurity systems are available.",
    options: [
      "Improvement on data and infromation protection is continous in our organisation.",
      "Our organisation have a clear defined policy on cybersecurity and has up-to-date cybersecurity systems.",
      "Our organisation is in the process of acquiring basic computer security softwares needed ",
      "Our organisation is equipped with the basic computer security needed for data and information protection",
      "Our organisation knows the importance of data and information protection and has plans towards ensuring up-to-date cybersecurity systems are available.",
    ],
  },
  {
    variable_id: "technology_9",
    element_id: "technology",
    variable_name: "Digital media marketing",
    question: "Which of the following digital media marketing statement best fit your organisation?",
    response: "Our organisation is still sceptical about the possible outcomes of adopting digital platforms to market its products and services ",
    options: [
      "Our organisations improves on its products and servcies through feedback from digital platforms",
      "Our organisations has been able to optimise the use of digital platforms for the continous marketing of its products and services",
      "There are plans to use digital platforms to market our organisation's products and services ",
      "Our organisations is using diverse digital platforms to market its  products and services",
      "Our organisation is still sceptical about the possible outcomes of adopting digital platforms to market its products and services ",
    ],
  },
  {
    variable_id: "technology_10",
    element_id: "technology",
    variable_name: "Continuous technology upgrades",
    question: "Please select the statement that is most applicable to your organisation in respect to continuous technology upgrades",
    response: "Technology upgrade in our organisation is done based on availability of resources and need",
    options: [
      "Plans for technology upgrade in our organisation is still at its infancy stage",
      "Technology usage is based on needs and availability, hence no upgrade is needed",
      "Our organisation has strict guidelines for evaluation of the performance of adopted technologies and their upgrades",
      "Technology upgrade in our organisation is continous.",
      "Technology upgrade in our organisation is done based on availability of resources and need",
    ],
  },
  {
    variable_id: "technology_11",
    element_id: "technology",
    variable_name: "Synergy between digital technology and other organisation’s resources",
    question:
      "Please select the statement that is most applicable to your organisation in respect to the Synergy between digital technology and other organisation’s resources",
    response: "Our organisation has been able to optise the synergy between digital technologies and other business opertations for improved innovativeness",
    options: [
      "Our organisations is improving on the use of digital technologies along side other resources to be more productive ",
      "Plans to link digital technologies with other organisation's resources are in advance stage in our organisations",
      "Plans to link digital technologies with other organisation's resources are in still at the infancy stage in our organisations",
      "There is a clear synergy between digital technologies and all other organisation resources.",
      "Our organisation has been able to optise the synergy between digital technologies and other business opertations for improved innovativeness",
    ],
  },
  {
    variable_id: "people_1",
    element_id: "people",
    variable_name: "Digital technical know-how of personnel",
    question: "Please select the statement that is most applicable to your organisation in respect to the digital technical know-how of personnel.",
    response: "Our organisation just began plans to have the required skilled personnel to handle digital tecghnologies ",
    options: [
      "In our organisation, continuous development is encouraged in improving the digital skills of workers  ",
      "Skilled personnel are available to handle digital technologies in our organisation  ",
      "Our organisation already understands the need for adequate skilled personnel to handle digital technologies and plans are in place to get the right skilled personnel needed.",
      "Our organisation emphasises the productivity of skilled personnel and enhances this through clear performance evaluation. ",
      "Our organisation just began plans to have the required skilled personnel to handle digital tecghnologies ",
    ],
  },
  {
    variable_id: "people_2",
    element_id: "people",
    variable_name: "Digital knowledge management by the organisation",
    question: "Which of the following statement regarding digital knowledge management best fit your organisation?",
    response:
      "Plans to adopt digital technologies that will aid proper management of knowledge that will enable our organisation become digital players are at the early stages.",
    options: [
      "Plans to adopt digital technologies that will aid proper management of knowledge that will enable our organisation become digitalplayers are at advance stages.",
      "In our organisation, the knowledge gained from digital technology deployment is properly managed for improved productivity and innovativeness.",
      "In our organisation, knowledge management through digital technologies is continuous and knowledge sharing cut across all functions of the organisations including external actors.",
      "In our organisation, digital technologies are used to effectively manage the knowledge gained from projects and this  knowledge is used to digitally transform the organisation.",
      "Plans to adopt digital technologies that will aid proper management of knowledge that will enable our organisation become digital players are at the early stages.",
    ],
  },
  {
    variable_id: "people_3",
    element_id: "people",
    variable_name: "Reskilling of workforce",
    question: "Which of the following 'workforce reskilling' statement best fit your organisation?",
    response: "Continuous improvement in the use of re-skilled employees in digital technology-related activities is evident in our organisation",
    options: [
      "In our organisation, plans to re-skill workers in the area of digital capability is at an advance stage. ",
      "Re-skilled employees are used in handling digital technology-related activities and improved productivity is evident in our organisation",
      "In our organisation, the importance of re-skilling talented employees is well defined and plans are in place.",
      "In our organisation, plans to re-skill workers in the area of digital capability is at the early stage.",
      "Continuous improvement in the use of re-skilled employees in digital technology-related activities is evident in our organisation",
    ],
  },
  {
    variable_id: "people_4",
    element_id: "people",
    variable_name: "Continuous learning of personnel",
    question: "Which of the following statements regarding 'personnel continous learning' best fit your organisation?",
    response: "In our organisation, employees learning is integrated with employees jobs",
    options: [
      "In our organisation, employees work and learning process are seperated",
      "For our organisation, learning for employees is continous.",
      "In our organisation, digital tools are used to ensure continous learning of employees",
      "Our organisation has perfected the act of learning on the job through effective use of digital tools",
      "In our organisation, employees learning is integrated with employees jobs",
    ],
  },
  {
    variable_id: "people_5",
    element_id: "people",
    variable_name: "Top management support",
    question: "Which of the following statement regarding 'top management support' best fit your organisation?",
    response: "Top management of my organisation are in the forefront of digitalisation of the construction industry.",
    options: [
      "Top management are improving on the plans put in place for digital transofrmation of our organisation ",
      "Top management support digital technology usage and plans are at advanced stage for digital transformation of the organisation ",
      "Top management in our organisation is still sceptical about the outcomes of adopting digital technologies",
      "Top management has clear objectives for the digital transformation of our oragnsiation and plans are in place to achieve these objectives ",
      "Top management of my organisation are in the forefront of digitalisation of the construction industry.",
    ],
  },
  {
    variable_id: "people_6",
    element_id: "people",
    variable_name: "Digital culture within an organisation",
    question: "Which of the following statement regarding 'digital culture' best fit your organisation?",
    response: "Our organisation understands the importance of havinga well defined digital culture and we are willing to learn from repeated adoption.",
    options: [
      "Our organisation prioritises the use of digital tools for more effective business operations",
      "Our organisation has no defined digital culture",
      "Our organisation has a clearly defined digital culture with well spelt out policies for digital tool deployment",
      "Our organisation is a digital disruptor in the construction industry.",
      "Our organisation understands the importance of havinga well defined digital culture and we are willing to learn from repeated adoption.",
    ],
  },
  {
    variable_id: "people_7",
    element_id: "people",
    variable_name: "Organisation’s positive change attitude",
    question: "Which of the following statement regarding 'positive change attitude' best fit your organisation?",
    response: "Our organisation has plans and measures in place to ensure positive changes are encouraged within the working environment",
    options: [
      "Our organisation embraces change and promote positive change attitude for more innovative ideas in the working environment",
      "Our organisation is always in the forefront of change both within and outside the organisation",
      "Our organisation's is willing to embrace change but are mostly unsure of the outcome.",
      "Our organisation's is mostly sceptical to embrace change when they occur",
      "Our organisation has plans and measures in place to ensure positive changes are encouraged within the working environment",
    ],
  },
  {
    variable_id: "people_8",
    element_id: "people",
    variable_name: "Digital empowerment of personnel",
    question: "Which of the following statement regarding 'digital empowerment' best fit your organisation?",
    response: "Our employees are empowered with the right digital tools to be innovative and productive",
    options: [
      "Plans to empower employees digitally are at advance stages with some technologies available within the organisation.",
      "In our organisation, plans to empower employees digitally are at early stages",
      "Our employees are empowered with the right digital tools to function in there day to day activities",
      "Our organisation is a digital empowerment of employees is a continous process",
      "Our employees are empowered with the right digital tools to be innovative and productive",
    ],
  },
  {
    variable_id: "people_9",
    element_id: "people",
    variable_name: "Personnel’s innovativeness",
    question: "Which of the following statement regarding 'personnel innovativeness' best fit your organisation?",
    response: "In our organisation, employees' innovativeness is based on their self-drive",
    options: [
      "Our employees are given the required assistance to be innovative and productive",
      "In our organisation, employees' innovativeness is not clearly defined",
      "Our employees knows the importance of innovativeness and are continously seeking new challenges",
      "Our employees are encouraged to be innovative in their day-to-day activities",
      "In our organisation, employees' innovativeness is based on their self-drive",
    ],
  },
  {
    variable_id: "people_10",
    element_id: "people",
    variable_name: "Attracting and retaining digital talent",
    question: "Which of the following statement regarding 'attarcting and retaining digital talent' best fit your organisation?",
    response:
      "Our organisations has clear objectives in attracting employees with digital talent and measures are put in place to ensure digital talents are retained.",
    options: [
      "Our organisation only attarcts and retain digital talents ",
      "Plans to attract and retain employees with digital talents is in advance stage in our organisation",
      "Plans to attract and retain employees with digital talents is still at the early stage in our organisation",
      "Our organisations continous to improve on its objectives of attracting and retaining employees with digital talent ",
      "Our organisations has clear objectives in attracting employees with digital talent and measures are put in place to ensure digital talents are retained.",
    ],
  },
  {
    variable_id: "process_1",
    element_id: "process",
    variable_name: "Digitalised planning process",
    question: "Which of the following statements regarding 'digitalised planning process' best fit your organisation?",
    response: "Our organisation understand the need to digitalise the planning process for project delivery and business operations. ",
    options: [
      "In our organisation, the right digital tools needed to digitalise the planning process for project delivery and business operations is known, and plans are in place towards achieving this.",
      "In our organisation, the planning process for project delivery and business operations is done using digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "In our organisation, the planning process for project delivery and business operations is not digitalised",
      "Continuous improvement of the digitalisation of the planning process for project delivery and business operations is achieved through the effective use of digital tools in our organisation",
      "Our organisation understand the need to digitalise the planning process for project delivery and business operations. ",
    ],
  },
  {
    variable_id: "process_2",
    element_id: "process",
    variable_name: "Automated construction process",
    question: "Which of the following statements regarding 'automated construction process' best fit your organisation?",
    response: "Our organisation understand the need to automate some of its operations, but the right tools needed are not completely known. ",
    options: [
      "In our organisation, there is a discussion on the need to automate certain operations, but plans towards achieving this is still at the infancy stage",
      "In our organisation, the right digital tools needed for the automation some of its operations is known, and plans are in place towards achieving a digitalised schedule management system",
      "Continuous improvement of the automation process is achieved through the effective use of digital tools in our organisation",
      "In our organisation, the automation of some operations is done using defined automation tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "Our organisation understand the need to automate some of its operations, but the right tools needed are not completely known. ",
    ],
  },
  {
    variable_id: "process_3",
    element_id: "process",
    variable_name: "Digitalised schedule management",
    question: "Which of the following statements regarding 'digitalised schedule management' best fit your organisation?",
    response:
      "In our organisation, the need for a digitalised schedule management is understood, but this is done using some available schedule software on a trial-and-error basis. ",
    options: [
      "In our organisation, schedule of the project is managed using defined digital tools. Guidelines for the performance measurement of these technologies are in place, and evaluation is done consistently.",
      "In our organisation, the right digital tools needed for the management of schedule is known, and plans are in place towards achieving a digitalised schedule management system",
      "In our organisation, there is a discussion on the need to be digitalise and traces of the use of schedule software can be found. But this is not with the aim of digitalisation the organisation's business operations",
      "Based on performance evaluation, continuous improvement of the schedule management system is achieved through the effective use of digital tools in our organisation",
      "In our organisation, the need for a digitalised schedule management is understood, but this is done using some available schedule software on a trial-and-error basis. ",
    ],
  },
  {
    variable_id: "process_4",
    element_id: "process",
    variable_name: "Digitalised resource management",
    question: "Which of the following statements regarding 'digitalised resource management' best fit your organisation?",
    response: "Currently in our organisation, resource allocation and management is done using some resource management software on a trial-and-error basis ",
    options: [
      "In our organisation, the management of resources is not digitalised, although consideration is being given to it.",
      "In our organisation, resources are managed using defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "Continuous improvement of the resource management system is achieved through the effective use of digital tools in our organisation",
      "In our organisation, the right digital tools needed for the management of resources is known, and plans are in place towards achieving a digitalised resource management system",
      "Currently in our organisation, resource allocation and management is done using some resource management software on a trial-and-error basis ",
    ],
  },
  {
    variable_id: "process_5",
    element_id: "process",
    variable_name: "Management of integrated service",
    question: "Which of the following statements regarding 'management of integrated service' best fit your organisation?",
    response:
      "In our organisation, the right digital tools (e.g BIM) needed for the management of elements in the delivery of optimum services are known and plans are in place towards achieving a digitalised integrated service management system",
    options: [
      "Continuous improvement of the integrated service system is achieved through the effective use of digital tools in our organisation",
      "Our organisation understands the need to digitally combine and coordinate different elements needed for optimum service delivery.",
      "In our organisation, the concept of integrated services is not clearly understood",
      "In our organisation, integrated service is managed using appropriately defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "In our organisation, the right digital tools (e.g BIM) needed for the management of elements in the delivery of optimum services are known and plans are in place towards achieving a digitalised integrated service management system",
    ],
  },
  {
    variable_id: "process_6",
    element_id: "process",
    variable_name: "Value delivery and quality management",
    question: "Which of the following statements regarding 'value delivery and quality management' best fit your organisation?",
    response:
      "In our organisation, value delivery and quality are managed using appropriately defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
    options: [
      "Continuous improvement of the digital management of  value delivery and quality is achieved through the effective use of digital tools in our organisation",
      "In our organisation, value delivery and quality management is not digitalised",
      "The digital tools needed to digitalise the value delivery and quality management system of our organisation are known, and plans are in place towards achieving this",
      "Our organisation understand the need to digitalise its value delivery and quality management system, but the right tools needed are not completely known. ",
      "In our organisation, value delivery and quality are managed using appropriately defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
    ],
  },
  {
    variable_id: "process_7",
    element_id: "process",
    variable_name: "Digitalised stakeholder management",
    question: "Which of the following statements regarding 'digitalised stakeholder management' best fit your organisation?",
    response: "Our organisation understand the need to digitally manage its stakeholders, but the right tools needed are not completely known. ",
    options: [
      "In our organisation, stakeholders are managed using appropriately defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "The digital tools needed to digitally manage stakeholders are known, and plans are in place towards achieving a digitalised stakeholder management system in our organisation",
      "In our organisation, the concept of digitally managing stakeholders is not clearly understood",
      "Continuous improvement of the digital management of stakeholders is achieved through the effective use of digital tools in our organisation",
      "Our organisation understand the need to digitally manage its stakeholders, but the right tools needed are not completely known. ",
    ],
  },
  {
    variable_id: "process_8",
    element_id: "process",
    variable_name: "Digitalised scope management",
    question: "Which of the following statements regarding 'digitalised scope management' best fit your organisation?",
    response: "Our organisation understand the need for a digitalised scope management, but the right tools needed are not completely known. ",
    options: [
      "In our organisation, the management of project scope is not done digitally ",
      "In our organisation, project scope is managed using defined digital tools, and performance measurement of these tools is done consistently.",
      "The digital tools needed for proper scope management are known, and plans are in place towards achieving a digitalised scope management system in our organisation",
      "Based on performance evaluation, continuous improvement of the project scope management is achieved through the effective use of digital digital tools in our organisation",
      "Our organisation understand the need for a digitalised scope management, but the right tools needed are not completely known. ",
    ],
  },
  {
    variable_id: "process_9",
    element_id: "process",
    variable_name: "Digitalised cost management process",
    question: "Which of the following statements regarding 'digitalised cost management process' best fit your organisation?",
    response:
      "Our organisation understand the need for a digitalised cost management system, but consistency in the use of the right digital tools that can effectively help manage cost is absent. ",
    options: [
      "The right technology needed for the management of cost is known , and plans are in place towards achieving a digitalised cost management system in our organisation",
      "Based on performance evaluation, continuous improvement is achieved through the effective use of digital digital tools in our organisation",
      "In our organisation, cost is managed using clearly defined digital tools and the performance measurement of these toolss is done consistently.",
      "Traces of the use of cost estimating and management software can be found in our organisation. However, this is not with the aim of digitalising the whole construction process",
      "Our organisation understand the need for a digitalised cost management system, but consistency in the use of the right digital tools that can effectively help manage cost is absent. ",
    ],
  },
  {
    variable_id: "process_10",
    element_id: "process",
    variable_name: "Digitalised procurement process",
    question: "Which of the following statements regarding 'digitalised procurement process' best fit your organisation?",
    response: "Our organisation has clearly defined policies on the use of e-procurement.",
    options: [
      "There is a mixture of the use of e-procurement and the traditional approach in our organisation",
      "Continuous improvement is achieved through the effective use of e-procurement in our organisation",
      "In our organisation, resources are procured strictly using e-procurement approach. Continuous evaluation of the system is conducted for improvement",
      "Our organisation still adopts the traditional procurement systems ",
      "Our organisation has clearly defined policies on the use of e-procurement.",
    ],
  },
  {
    variable_id: "process_11",
    element_id: "process",
    variable_name: "Digital risk management",
    question: "Which of the following statements regarding 'digital risk management' best fit your organisation?",
    response: "The right digital risk-mitigating measure to be adopted in the case of unforeseen problems is defined within our organisation ",
    options: [
      "Fear of unforeseen consequences of digitalisation serves as a barrier to the digital transformation of our organisation. ",
      "Our organisation understands the need to be prepared for unforeseen consequences of digitalising and we are willing to learn from past mistakes. ",
      "Our organisation is continuously improving on its mitigating measures for unforeseen consequences of digitalisation of its services.",
      "Digital risk is effectively managed using appropriate digital tools and continuous conducted in our organisation.",
      "The right digital risk-mitigating measure to be adopted in the case of unforeseen problems is defined within our organisation ",
    ],
  },
  {
    variable_id: "process_12",
    element_id: "process",
    variable_name: "Change management",
    question: "Which of the following statements regarding 'change management' best fit your organisation?",
    response: "Our organisation learns from previous changes and are willing to adopt digital tools needed to ease the management of these changes.",
    options: [
      "Our organisation actively manage changes and build adaptive capacity through the strategic application of digital tools.",
      "In our organisation, changes are handled as they come along. ",
      "Our organisation sees the importance of change management and have the digital tools necessary to manage changes.",
      "Continuous improvement of change management within our organisation is evident.",
      "Our organisation learns from previous changes and are willing to adopt digital tools needed to ease the management of these changes.",
    ],
  },
  {
    variable_id: "process_13",
    element_id: "process",
    variable_name: "Communication management",
    question: "Which of the following statements regarding 'communication management' best fit your organisation?",
    response: "In our organisation, communication is managed using defined digital tools, and performance measurement of these tools is done consistently.",
    options: [
      "Our organisation still adopts the traditional communication approaches",
      "Based on performance evaluation, continuous improvement of communication management is achieved through the effective use of digital digital tools in our organisation",
      "The digital tools needed for effective communication are known, and plans are in place towards achieving a digitalised communication system in our organisation",
      "Our organisation understand the need for a digitalised communication system",
      "In our organisation, communication is managed using defined digital tools, and performance measurement of these tools is done consistently.",
    ],
  },
  {
    variable_id: "strategy_1",
    element_id: "strategy",
    variable_name: "Research and development",
    question: "Which of the following statements regarding 'research and development' best fit your organisation?",
    response: "The support for R&D in our organisation is low. ",
    options: [
      "In our organisation, R&D is a major source of decision making, hence considerable support is given to the process.",
      "In our organsiation, the need for R&D is defined and plans towards achieving effective R&D are in place.",
      "Our organisation does not fund R&D",
      "Our organisation leads the construction industry discoruse on digital transformation due to its investment in R&D.",
      "The support for R&D in our organisation is low. ",
    ],
  },
  {
    variable_id: "strategy_2",
    element_id: "strategy",
    variable_name: "Digital technology selection",
    question: "Which of the following statements regarding 'digital technology selection' best fit your organisation?",
    response:
      "Our organisation continues to improve on its guidelines for digital technology selection through proper evaluation of the performance of already adopted technologies",
    options: [
      "Our organisation understand the importance of being uptodate with the latest digital technology in the quest for digital transformation",
      "In our organisation the choice of the right digital technology to use is still fuzzy",
      "Our organisation has guidelines for the selection of digital technologies and this selection is done based on input from both management and employees",
      "In our organisation, the the choice of the right digital technology to use is known and the selection is strictly a management function.",
      "Our organisation continues to improve on its guidelines for digital technology selection through proper evaluation of the performance of already adopted technologies",
    ],
  },
  {
    variable_id: "strategy_3",
    element_id: "strategy",
    variable_name: "Forecasting client’s need",
    question: "Which of the following statements regarding 'forecasting client’s need' best fit your organisation?",
    response:
      "Our organisation strives to continously improve its understanding of clients needs through the improvement of its adoption of digital technologies",
    options: [
      "In our organisation, clients needs are forecasted using digital technologies",
      "Our organisatin deals with clients needs as they arise",
      "Our organisation understand the needs to forcast cleints needs using digital technologies, and are prepared to learn through series of repetitive processess.",
      "Our organisation strives to continously improve its understanding of clients needs through the improvement of its adoption of digital technologies",
    ],
  },
  {
    variable_id: "strategy_4",
    element_id: "strategy",
    variable_name: "Project and service boundary",
    question: "Which of the following statements regarding 'project and service boundary' best fit your organisation?",
    response: "Our organisation understand the need for a clear boundary for its services and plans are being set to achieve this.",
    options: [
      "Our organisation is leading projects and service delivery within its defined space through the use of digital technology",
      "Our organisation has no defined boundary for its project and services",
      "Our organisation continues to use digital technology to improve on its servcies within the set boundaries. Guidelines for evaluating our organsiation's performance within this set area is clear.",
      "Our organisation has been able to clearly set out boundaries for its projects and services in a bid to be specialised through the sue of defined digital technologies.",
      "Our organisation understand the need for a clear boundary for its services and plans are being set to achieve this.",
    ],
  },
  {
    variable_id: "strategy_5",
    element_id: "strategy",
    variable_name: "Clients' feedback evaluation",
    question: "Which of the following statements regarding 'clients' feedback evaluation' best fit your organisation?",
    response:
      "Our organisation strives to continously improve its services to its clients through the improvement of the evaluation of clients feedback using digital technologies",
    options: [
      "In our organisation, clients' feedback are carefully evaluated using digital technologies",
      "Our organisation understand the need to carefully evaluate cleints' feedback using digital technologies, and are prepared to learn through series of repetitive processess.",
      "Our organisation strives to continously improve its services to its clients through the improvement of the evaluation of clients feedback using digital technologies",
    ],
  },
  {
    variable_id: "strategy_6",
    element_id: "strategy",
    variable_name: "Investment in digital technology",
    question: "Which of the following statements regarding 'investment in digital technology' best fit your organisation?",
    response: "Plans to invest on digital technologies is at an advance stage in our organisation",
    options: [
      "Our organisation has implemented plans to invest in digiatl technologies",
      "Our organisation cannot afford to invest on digital technologies at this stage",
      "Our organisation is a digital disruptor in the construction industry as investment in emerging technologies are continuous",
      "Our organisation is continuously increasing its investment in digital technologies. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently. ",
      "Plans to invest on digital technologies is at an advance stage in our organisation",
    ],
  },
  {
    variable_id: "strategy_7",
    element_id: "strategy",
    variable_name: "Decision-making procedure",
    question: "Which of the following statements regarding 'decision-making procedure' best fit your organisation?",
    response: "In our organisation, decision-making procedure is rapid and its based on the outcomes from the use of digital tools",
    options: [
      "In our organsiation, the decision-making procedure for digital tool deployment is slow ",
      "Our organisation continues to improve in its decision making through effective use of digital tools",
      "The decision-making for digital tool deployment is subject to the outcome of the previous adoption.",
      "In our organisation, decision-making procedure is rapid and its based on the outcomes from the use of digital tools",
    ],
  },
  {
    variable_id: "strategy_8",
    element_id: "strategy",
    variable_name: "Digitalised performance measurement",
    question: "Which of the following statements regarding 'digitalised performance measurement' best fit your organisation?",
    response: "Our continues to improve on its performance measurement through the use of digital tools and guidelines for improvement are in place.",
    options: [
      "In our organisation, performance measurement is not digitalised",
      "Performance measurement in our organisation is done through the use of digital tools. ",
      "Ourorganisation continues to improve in its performance due to its continuous performance measurement done using digital tools.",
      "Our organisation plans on digitalising its performance measurement approach. ",
      "Our continues to improve on its performance measurement through the use of digital tools and guidelines for improvement are in place.",
    ],
  },
  {
    variable_id: "strategy_9",
    element_id: "strategy",
    variable_name: "Information and communication management",
    question: "Which of the following statements regarding 'iInformation and communication management' best fit your organisation?",
    response: "Information on digitalisation strategy is kept on a tight leash among top management in our organisation",
    options: [
      "In our organisation, digitalisation is properly communicated to all within the organisation and external actors (such as clients)",
      "In our organisation, there is no effective communication of digitalisation strategies ",
      "Digital strategy to be adopted in constantly being improved upon through continuous adoption of emerging technologies in our organisation.",
      "Digitalisation strategy is clearly defined and communicated to management and employees of our organisation",
      "Information on digitalisation strategy is kept on a tight leash among top management in our organisation",
    ],
  },
  {
    variable_id: "strategy_10",
    element_id: "strategy",
    variable_name: "Digital alignment of business",
    question: "Which of the following statements regarding 'digital alignment of business' best fit your organisation?",
    response: "There is a technology-driven transparency through digital technology usage in our organisation. ",
    options: [
      "Continuous improvement in aligning business goals with digitalisation is evident in our organisation",
      "Our organisation have objectives towards aligning the business with the digitalisation in place.",
      "In our organisation, the business goal is disjointed from the digital tools adopted",
      "There are some reservations regarding the  alignment of business with digitalisation in our organisation. ",
      "There is a technology-driven transparency through digital technology usage in our organisation. ",
    ],
  },
  {
    variable_id: "environment_1",
    element_id: "environment",
    variable_name: "Clients’ pressure",
    question: "Which of the following statements regarding 'client pressure' best fit your organisation?",
    response:
      "In our organisation, there is continuous improvement in converting client’s pressure to adopt digital technologies into positive drive for innovativeness and digital transformation.",
    options: [
      "Our organisation understands the importance of clients' pressure to adopt digital technologies, but the plans to adopt are still at the infancy stage.",
      "A clear understanding of the ever-changing taste of clients in known, and the need to continuously implement emerging technologies to meet this demand is clearly defined in our organisation",
      "Our organisation understands the importance of client pressure to adopt digital technologies, and effort are being made to adopt digital technologies in deliverying servcies to our cleints",
      "In our organisation, clients ever-changing desires are met with the adoption of emerging digital technologies needed to fulfil these desires. ",
      "In our organisation, there is continuous improvement in converting client’s pressure to adopt digital technologies into positive drive for innovativeness and digital transformation.",
    ],
  },
  {
    variable_id: "environment_2",
    element_id: "environment",
    variable_name: "Suppliers’ pressure",
    question: "Which of the following statements regarding 'supplier pressure' best fit your organisation?",
    response: "In our organisation, suppliers pressure are used as a positive drive to be innovative through proper digital technology deployment",
    options: [
      "Our organisation has a clear objective to continuously adopt emerging technologies as required by our uppliers.",
      "In our organisation, there is continuous improvement in converting suppliers' pressure to adopt digital technologies into positive drive for innovativeness and digital transformation.",
      "Our organisation understands the importance of suppliers' pressure to adopt digital technologies, and effort are being made to ensure the adoption of digital technologies ",
      "Our organisation understands the importance of suppliers' pressure to adopt digital technologies, but plans to adopt are still at the infancy stage.",
      "In our organisation, suppliers pressure are used as a positive drive to be innovative through proper digital technology deployment",
    ],
  },
  {
    variable_id: "environment_3",
    element_id: "environment",
    variable_name: "Competitors’ influence",
    question: "Which of the following statements regarding 'competitor influence' best fit your organisation?",
    response:
      "Our organisation is improving in its obejcetives to use digital technology in order to stay ahead of the comeptition within the construction industry.",
    options: [
      "Our organisation recognises that our competitors are adopting digtal technologies and plans to do the same is in progress",
      "Our organisation is leading the deployment of  digital technology within the construction industry",
      "Our organisation has put plans in place to adopt some digital technologies used by our competitors. ",
      "Our organisation has clearly defined objectives in digital technology usage in order to remain competitive within the construction industry.",
      "Our organisation is improving in its obejcetives to use digital technology in order to stay ahead of the comeptition within the construction industry.",
    ],
  },
  {
    variable_id: "environment_4",
    element_id: "environment",
    variable_name: "Government legislation",
    question: "Which of the following statements regarding 'government legislation' best fit your organisation?",
    response: "In our organisation, government legislations are continuously converted into a positive drive for adopting technologies",
    options: [
      "Our organisation recognises the importance of government legislations on the deployment of digital tools for construction project delivery",
      "Our organisation sees government legislation on the use of digital tools as a positive drive to be digitally transformed",
      "Our organisation adheres to the government legislations on the deployment of digital tools for construction project delivery",
      "In our organisation, government legislations are continuously converted into a positive drive for adopting technologies",
    ],
  },
  {
    variable_id: "environment_5",
    element_id: "environment",
    variable_name: "Industry rules and regulations",
    question: "Which of the following statements regarding 'industry regulation' best fit your organisation?",
    response:
      "Our organisation recognises the importance of industry rules and regulations on the deployment of digital tools for construction project delivery",
    options: [
      "Our organisation sees industry rules and regulations on the use of digital tools as a positive drive to be digitally transformed",
      "Our organisation adheres to the industry rules and regulations on the deployment of digital tools for construction project delivery",
      "In our organisation, industry rules and regulations are continuously converted into a positive drive for adopting technologies",
      "Our organisation recognises the importance of industry rules and regulations on the deployment of digital tools for construction project delivery",
    ],
  },
  {
    variable_id: "environment_6",
    element_id: "environment",
    variable_name: "Market scope",
    question: "Which of the following statements regarding 'market scope' best fit your organisation?",
    response: "Our organisation understands the importance of its target market and plans to use it to shape its digital transformation",
    options: [
      "Our organisation uses its market scope to shape our digital transformation and produce defined products for its target market",
      "In our organisation, there is continuous improvement in the use of our market scope in shaping our digital tramsformation.",
      "In our organisation, there are clear objectives to align our digital transformation with our target market requirement",
      "Our organisation understands the importance of its target market and plans to use it to shape its digital transformation",
      "In our organisation, the target market of does not infleunce our descision to be digitalised",
    ],
  },
  {
    variable_id: "environment_7",
    element_id: "environment",
    variable_name: "Environmental impact assessment",
    question: "Which of the following statements regarding 'environmental impact assessment' best fit your organisation?",
    response:
      "Our organisation have clearly defined objectives and policies on the use of digital technologies and processes that does not harm the environment",
    options: [
      "In our organisation, the environmental impact does not infleunce our descision to use digital technologies and innovative processes",
      "Our organisation recognises the importance of adopting digital technologies and processes that does harm the environment",
      "Our organisation is leading the deployment of  digital technologies that create no harm to the immediate environment",
      "Our organisation continues to improve on its objectives and plocies on the use of digital technologies and processes that does not harm the environment",
      "Our organisation have clearly defined objectives and policies on the use of digital technologies and processes that does not harm the environment",
    ],
  },
  {
    variable_id: "digital_partnering_1",
    element_id: "digital_partnering",
    variable_name: "Digital partner selection",
    question: "Which of the following statements regarding 'digital partner selection' best fit your organisation?",
    response: "For our organisation, careful selection of digital partners is done from within and outside the construction industry",
    options: [
      "Our organisation understands the need to partner, and are willing to learn from series of partnering relationships",
      "Our organisation have clearly defined list of organisations to partner withand their complementary digital capabilities are known to us.",
      "In our organisation, there is a continuous improvement of the selection of potential partners for digital partnering relationship",
      "In our organisation, digital partnering is not considered",
      "For our organisation, careful selection of digital partners is done from within and outside the construction industry",
    ],
  },
  {
    variable_id: "digital_partnering_2",
    element_id: "digital_partnering",
    variable_name: "Top management support for digital partnering",
    question: "Which of the following statements regarding 'top management support' best fit your organisation?",
    response:
      "Top management of my organisation are constantly seeking new organisations to partner up with in the quest for continuous digital transformation",
    options: [
      "Top management has clear objectives and policies regarding digital partnering in our oragnsiation.",
      "Top management are continuosly improving on the objectives and policies for digital partnering in our organisation ",
      "In our organisation, digital partnering is not considered",
      "Top management supports digital partnering and plans are at advanced stages to partner with other digital oriented organisations within and outside the industry.",
      "Top management of my organisation are constantly seeking new organisations to partner up with in the quest for continuous digital transformation",
    ],
  },
  {
    variable_id: "digital_partnering_3",
    element_id: "digital_partnering",
    variable_name: "Long-term commitment to digital partnering",
    question: "Which of the following statements regarding 'long-term commitment' best fit your organisation?",
    response: "The intention to create a long-term commitment to the digital partnering relationship is clearly defined within our organisation",
    options: [
      "Continuous improvement in the long-term digital partnering relationship created.",
      "In our organisation, digital partnering is not considered",
      "Since our organisation is just beginning its digital transformation joruney, partnering with other organisation for this puprose is only on a short-term bases",
      "In our organisation, digital partnering is strategic, and the emphasis is placed on achieving digital transformation in the long run.",
      "The intention to create a long-term commitment to the digital partnering relationship is clearly defined within our organisation",
    ],
  },
  {
    variable_id: "digital_partnering_4",
    element_id: "digital_partnering",
    variable_name: "Conflict resolution in digital partnering",
    question: "Which of the following statements regarding 'conflict resolution' best fit your organisation?",
    response: "Our organisation ensures conflict resolution is positive with a win-win approach in the mind of all digital partners",
    options: [
      "Our organisation has a clearly defined laid down conflict resolution approachfor digital partnering relationship.",
      "Our organisation is still at the planning phase of digital partnering, and pricinples for conflict resoultion are still at the early stages of conceptualisation",
      "In our organisation, digital partnering is not considered",
      "There is a continuous improvement in the conflict resolution approach adopted in the digital partnering relationship",
      "Our organisation ensures conflict resolution is positive with a win-win approach in the mind of all digital partners",
    ],
  },
  {
    variable_id: "digital_partnering_5",
    element_id: "digital_partnering",
    variable_name: "Trust in digital partners",
    question: "Which of the following statements regarding 'trust in digital partners' best fit your organisation?",
    response: "Our organisation have clearly defined principles that will help build trust in the  complementary digital capabilities of our partners",
    options: [
      "Our organisation trust in the digital capabilities of our partners.",
      "In our organisation, digital partnering is not considered",
      "Our organisation understands the for trust, and are willing to learn from series of partnering relationships",
      "In our organisation, there is a continuous improvement of trust building principles and activities, to ensure improved digital partnering relationship. ",
      "Our organisation have clearly defined principles that will help build trust in the  complementary digital capabilities of our partners",
    ],
  },
  {
    variable_id: "digital_partnering_6",
    element_id: "digital_partnering",
    variable_name: "Common goal in the partnering process",
    question: "Which of the following statements regarding 'common goal in the partnering process' best fit your organisation?",
    response: "Our organisation continue to improve on the set goals and align them with that of our partners in every digital partnering relationship",
    options: [
      "Our organisation understands the the need to have common goals in every partnering relationship and are willing to learn from series of partnering relationships",
      "In our organisation, there is a continuous strive for a common goal in digital partnering relationship",
      "In our organisation, digital partnering is not considered",
      "Our organisation have clearly defined goals to be achieved from every digital partnering relationship.",
      "Our organisation continue to improve on the set goals and align them with that of our partners in every digital partnering relationship",
    ],
  },
];
///////unshuffled dre should always be the exact duplicate of const dret below...... after changing dret, copy dret and rename constant unshuffled dret
const unshuffled_dret = [
  {
    variable_id: "technology_1",
    element_id: "technology",
    variable_name: "Technology planning",
    question: "Which of the following technology planning statement best fit your organisation?",
    response: "",
    options: [
      "Our organisation is still sceptical about the outcomes of adopting digital technologies",
      "The plan to digitally transform our organisation's business function using emerging digital technologies is at the infancy stage",
      "There are carefully thought out plans in place to ensure the  adoption of emerging digital technologies within our organisation",
      "Our organisation understands the requirement needed for digitalisation of our business function and effort have been made to ensure all resources needed are available",
      "Our organisation continues to improve on its techgnology planning and signifcant outcomes are being derived through the used of well planned digital technology adoption.",
    ],
  },

  {
    variable_id: "technology_2",
    element_id: "technology",
    variable_name: "Optimisation of Emerging technologies e.g BIM",
    question:
      "Please select the statement that is most applicable to your organisation in respect to the extent of adoption and optimisation of emerging digital technologies.",
    response: "",
    options: [
      "Very few digital technologies are adopted  for the sole purpose of easing our day-to-day organisational functions.",
      "My organisation is in a learning phase and as such only few digital technologies are adopted with the intent of digitising  organisational functions.",
      "My organisation understand the need to  adopt emerging digital technologies  and plans towards adopting them to digitalise the organisation's services.",
      "We have set quantifiable goals for digital transofrmation of the organisation, and significant improvement in construction productivity is being made through the use of digital technologies. ",
      "My organisation is a digital disruptor and it leads the construction industry discussion on digital transformation.",
    ],
  },

  {
    variable_id: "technology_3",
    element_id: "technology",
    variable_name: "Big data analytics",
    question: "Please select the statement that is most applicable to your organisation in respect to big data analytics.",
    response: "",
    options: [
      "Our organisation has no defined data analystics system ",
      "Our organisation understands the need to analyse data from past projects, but do not have the capability to correctly mine and analyse the data",
      "Our organisation have the digital technologies needed to mine and analyse data.",
      "Our organisation's decision-making is largely data-driven. ",
      "In our organisation, there is a continuous improvement in data analytics ",
    ],
  },

  {
    variable_id: "technology_4",
    element_id: "technology",
    variable_name: "Additive manufacturing (3D Printing)",
    question: "Please select the statement that is most applicable to your organisation in respect to the use of additive manufacturing.",
    response: "",
    options: [
      "Presently, our organisation lacks the capability to adopt 3D printing and we are sceptical about the inherent benefits",
      "Our organisation understands the importance of 3D printing in construction and we are willing to learn from repeated adoption. However, we are challenged by limited resources",
      "Our organisation understands the importance of 3D printing in construction. Clear policy regarding the adoption of this technology are already in place.",
      "Our organisation's prioritises the use of 3D printing in delivering more efficient construction projects.",
      "Our organisation has been able to optimise the use of 3D printing in our delivery of construction projects.",
    ],
  },

  {
    variable_id: "technology_5",
    element_id: "technology",
    variable_name: "Cloud computing/Connected things ",
    question: "Please select the statement that is most applicable to your organisation in respect to the use of cloud computing.",
    response: "",
    options: [
      "Our organisation has no defined data storage system and the use of internet is majorly of small office functions ",
      "Our organisation use technology such as computers and hardrives to store data and assess to any form of computing must be done within the organisation",
      "Our data storage and computing process is done over the internet ('the cloud')",
      "In our organisation, computing resoruces and data storage are centralised and easily shared for faster and more effeicent information exchange in improved productivity. ",
      "In our organisation, there is a continuous improvement in the use of cloud computing ",
    ],
  },

  {
    variable_id: "technology_6",
    element_id: "technology",
    variable_name: "Design simulation and visualisation",
    question: "Please select the statement that is most applicable to your organisation in respect to the use of design simulation and visualisation tools.",
    response: "",
    options: [
      "Presently, the adoption of simulation and visualisation tools is at the early planning stage in our organisation",
      "Our organisation understands the importance of design simulation and visualisation and we are willing to learn from repeated adoption. However, we are challenged by limited resources",
      "Our organisation understands the importance of design simulation and visualisation. Clear policy regarding the adoption of related technologies are already in place.",
      "Our organisation prioritises the use of design simulation and visualisation tools in creating a better experience for our clients",
      "Our organisation has been able to optimise the use of design simulation and visualisation tools in our  delivery of quality services to our clients. ",
    ],
  },

  {
    variable_id: "technology_7",
    element_id: "technology",
    variable_name: "Robotics and automation in construction",
    question: "Please select the statement that is most applicable to your organisation in respect to the use of robotics and automation.",
    response: "",
    options: [
      "Currently, our organisation lacks the capability to adopt robotics and automation and we are sceptical about the inherent benefits",
      "Our organisation understands the importance of robotics and automation in construction and we are willing to learn from repeated adoption. However, we are challenged by limited resources",
      "Our organisation understands the importance of robotics and automation in construction. Clear policy regarding the adoption of this technology are already in place.",
      "Our organisation's prioritises the use of robotics and automation in delivering more efficient construction projects.",
      "Our organisation has been able to optimise the use of robotics and automation in our  delivery of construction projects. ",
    ],
  },

  {
    variable_id: "technology_8",
    element_id: "technology",
    variable_name: "Cybersecurity",
    question: "Which of the following cybersecurity statement best fit your organisation?",
    response: "",
    options: [
      "Our organisation is in the process of acquiring basic computer security softwares needed ",
      "Our organisation is equipped with the basic computer security needed for data and information protection",
      "Our organisation knows the importance of data and information protection and has plans towards ensuring up-to-date cybersecurity systems are available.",
      "Our organisation have a clear defined policy on cybersecurity and has up-to-date cybersecurity systems.",
      "Improvement on data and infromation protection is continous in our organisation.",
    ],
  },

  {
    variable_id: "technology_9",
    element_id: "technology",
    variable_name: "Digital media marketing",
    question: "Which of the following digital media marketing statement best fit your organisation?",
    response: "",
    options: [
      "Our organisation is still sceptical about the possible outcomes of adopting digital platforms to market its products and services ",
      "There are plans to use digital platforms to market our organisation's products and services ",
      "Our organisations is using diverse digital platforms to market its  products and services",
      "Our organisations improves on its products and servcies through feedback from digital platforms",
      "Our organisations has been able to optimise the use of digital platforms for the continous marketing of its products and services",
    ],
  },

  {
    variable_id: "technology_10",
    element_id: "technology",
    variable_name: "Continuous technology upgrades",
    question: "Please select the statement that is most applicable to your organisation in respect to continuous technology upgrades",
    response: "",
    options: [
      "Technology usage is based on needs and availability, hence no upgrade is needed",
      "Plans for technology upgrade in our organisation is still at its infancy stage",
      "Technology upgrade in our organisation is done based on availability of resources and need",
      "Our organisation has strict guidelines for evaluation of the performance of adopted technologies and their upgrades",
      "Technology upgrade in our organisation is continous.",
    ],
  },

  {
    variable_id: "technology_11",
    element_id: "technology",
    variable_name: "Synergy between digital technology and other organisation’s resources",
    question:
      "Please select the statement that is most applicable to your organisation in respect to the Synergy between digital technology and other organisation’s resources",
    response: "",
    options: [
      "Plans to link digital technologies with other organisation's resources are in still at the infancy stage in our organisations",
      "Plans to link digital technologies with other organisation's resources are in advance stage in our organisations",
      "There is a clear synergy between digital technologies and all other organisation resources.",
      "Our organisations is improving on the use of digital technologies along side other resources to be more productive ",
      "Our organisation has been able to optise the synergy between digital technologies and other business opertations for improved innovativeness",
    ],
  },

  ////////////////begin people

  {
    variable_id: "people_1",
    element_id: "people",
    variable_name: "Digital technical know-how of personnel",
    question: "Please select the statement that is most applicable to your organisation in respect to the digital technical know-how of personnel.",
    response: "",
    options: [
      "Our organisation just began plans to have the required skilled personnel to handle digital tecghnologies ",
      "Our organisation already understands the need for adequate skilled personnel to handle digital technologies and plans are in place to get the right skilled personnel needed.",
      "Skilled personnel are available to handle digital technologies in our organisation  ",
      "Our organisation emphasises the productivity of skilled personnel and enhances this through clear performance evaluation. ",
      "In our organisation, continuous development is encouraged in improving the digital skills of workers  ",
    ],
  },

  {
    variable_id: "people_2",
    element_id: "people",
    variable_name: "Digital knowledge management by the organisation",
    question: "Which of the following statement regarding digital knowledge management best fit your organisation?",
    response: "",
    options: [
      "Plans to adopt digital technologies that will aid proper management of knowledge that will enable our organisation become digital players are at the early stages.",
      "Plans to adopt digital technologies that will aid proper management of knowledge that will enable our organisation become digitalplayers are at advance stages.",
      "In our organisation, digital technologies are used to effectively manage the knowledge gained from projects and this  knowledge is used to digitally transform the organisation.",
      "In our organisation, the knowledge gained from digital technology deployment is properly managed for improved productivity and innovativeness.",
      "In our organisation, knowledge management through digital technologies is continuous and knowledge sharing cut across all functions of the organisations including external actors.",
    ],
  },

  {
    variable_id: "people_3",
    element_id: "people",
    variable_name: "Reskilling of workforce",
    question: "Which of the following 'workforce reskilling' statement best fit your organisation?",
    response: "",
    options: [
      "In our organisation, plans to re-skill workers in the area of digital capability is at the early stage.",
      "In our organisation, plans to re-skill workers in the area of digital capability is at an advance stage. ",
      "In our organisation, the importance of re-skilling talented employees is well defined and plans are in place.",
      "Re-skilled employees are used in handling digital technology-related activities and improved productivity is evident in our organisation",
      "Continuous improvement in the use of re-skilled employees in digital technology-related activities is evident in our organisation",
    ],
  },

  {
    variable_id: "people_4",
    element_id: "people",
    variable_name: "Continuous learning of personnel",
    question: "Which of the following statements regarding 'personnel continous learning' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, employees work and learning process are seperated",
      "In our organisation, employees learning is integrated with employees jobs",
      "In our organisation, digital tools are used to ensure continous learning of employees",
      "Our organisation has perfected the act of learning on the job through effective use of digital tools",
      "For our organisation, learning for employees is continous.",
    ],
  },

  {
    variable_id: "people_5",
    element_id: "people",
    variable_name: "Top management support",
    question: "Which of the following statement regarding 'top management support' best fit your organisation?",
    response: "",
    options: [
      "Top management in our organisation is still sceptical about the outcomes of adopting digital technologies",
      "Top management support digital technology usage and plans are at advanced stage for digital transformation of the organisation ",
      "Top management has clear objectives for the digital transformation of our oragnsiation and plans are in place to achieve these objectives ",
      "Top management are improving on the plans put in place for digital transofrmation of our organisation ",
      "Top management of my organisation are in the forefront of digitalisation of the construction industry.",
    ],
  },

  {
    variable_id: "people_6",
    element_id: "people",
    variable_name: "Digital culture within an organisation",
    question: "Which of the following statement regarding 'digital culture' best fit your organisation?",
    response: "",
    options: [
      "Our organisation has no defined digital culture",
      "Our organisation understands the importance of havinga well defined digital culture and we are willing to learn from repeated adoption.",
      "Our organisation has a clearly defined digital culture with well spelt out policies for digital tool deployment",
      "Our organisation prioritises the use of digital tools for more effective business operations",
      "Our organisation is a digital disruptor in the construction industry.",
    ],
  },

  {
    variable_id: "people_7",
    element_id: "people",
    variable_name: "Organisation’s positive change attitude",
    question: "Which of the following statement regarding 'positive change attitude' best fit your organisation?",
    response: "",
    options: [
      "Our organisation's is mostly sceptical to embrace change when they occur",
      "Our organisation's is willing to embrace change but are mostly unsure of the outcome.",
      "Our organisation has plans and measures in place to ensure positive changes are encouraged within the working environment",
      "Our organisation embraces change and promote positive change attitude for more innovative ideas in the working environment",
      "Our organisation is always in the forefront of change both within and outside the organisation",
    ],
  },

  {
    variable_id: "people_8",
    element_id: "people",
    variable_name: "Digital empowerment of personnel",
    question: "Which of the following statement regarding 'digital empowerment' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, plans to empower employees digitally are at early stages",
      "Plans to empower employees digitally are at advance stages with some technologies available within the organisation.",
      "Our employees are empowered with the right digital tools to function in there day to day activities",
      "Our employees are empowered with the right digital tools to be innovative and productive",
      "Our organisation is a digital empowerment of employees is a continous process",
    ],
  },

  {
    variable_id: "people_9",
    element_id: "people",
    variable_name: "Personnel’s innovativeness",
    question: "Which of the following statement regarding 'personnel innovativeness' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, employees' innovativeness is not clearly defined",
      "In our organisation, employees' innovativeness is based on their self-drive",
      "Our employees are encouraged to be innovative in their day-to-day activities",
      "Our employees are given the required assistance to be innovative and productive",
      "Our employees knows the importance of innovativeness and are continously seeking new challenges",
    ],
  },

  {
    variable_id: "people_10",
    element_id: "people",
    variable_name: "Attracting and retaining digital talent",
    question: "Which of the following statement regarding 'attarcting and retaining digital talent' best fit your organisation?",
    response: "",
    options: [
      "Plans to attract and retain employees with digital talents is still at the early stage in our organisation",
      "Plans to attract and retain employees with digital talents is in advance stage in our organisation",
      "Our organisations has clear objectives in attracting employees with digital talent and measures are put in place to ensure digital talents are retained.",
      "Our organisations continous to improve on its objectives of attracting and retaining employees with digital talent ",
      "Our organisation only attarcts and retain digital talents ",
    ],
  },

  ///////begin process
  {
    variable_id: "process_1",
    element_id: "process",
    variable_name: "Digitalised planning process",
    question: "Which of the following statements regarding 'digitalised planning process' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, the planning process for project delivery and business operations is not digitalised",
      "Our organisation understand the need to digitalise the planning process for project delivery and business operations. ",
      "In our organisation, the right digital tools needed to digitalise the planning process for project delivery and business operations is known, and plans are in place towards achieving this.",
      "In our organisation, the planning process for project delivery and business operations is done using digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "Continuous improvement of the digitalisation of the planning process for project delivery and business operations is achieved through the effective use of digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_2",
    element_id: "process",
    variable_name: "Automated construction process",
    question: "Which of the following statements regarding 'automated construction process' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, there is a discussion on the need to automate certain operations, but plans towards achieving this is still at the infancy stage",
      "Our organisation understand the need to automate some of its operations, but the right tools needed are not completely known. ",
      "In our organisation, the right digital tools needed for the automation some of its operations is known, and plans are in place towards achieving a digitalised schedule management system",
      "In our organisation, the automation of some operations is done using defined automation tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "Continuous improvement of the automation process is achieved through the effective use of digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_3",
    element_id: "process",
    variable_name: "Digitalised schedule management",
    question: "Which of the following statements regarding 'digitalised schedule management' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, there is a discussion on the need to be digitalise and traces of the use of schedule software can be found. But this is not with the aim of digitalisation the organisation's business operations",
      "In our organisation, the need for a digitalised schedule management is understood, but this is done using some available schedule software on a trial-and-error basis. ",
      "In our organisation, the right digital tools needed for the management of schedule is known, and plans are in place towards achieving a digitalised schedule management system",
      "In our organisation, schedule of the project is managed using defined digital tools. Guidelines for the performance measurement of these technologies are in place, and evaluation is done consistently.",
      "Based on performance evaluation, continuous improvement of the schedule management system is achieved through the effective use of digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_4",
    element_id: "process",
    variable_name: "Digitalised resource management",
    question: "Which of the following statements regarding 'digitalised resource management' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, the management of resources is not digitalised, although consideration is being given to it.",
      "Currently in our organisation, resource allocation and management is done using some resource management software on a trial-and-error basis ",
      "In our organisation, the right digital tools needed for the management of resources is known, and plans are in place towards achieving a digitalised resource management system",
      "In our organisation, resources are managed using defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "Continuous improvement of the resource management system is achieved through the effective use of digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_5",
    element_id: "process",
    variable_name: "Management of integrated service",
    question: "Which of the following statements regarding 'management of integrated service' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, the concept of integrated services is not clearly understood",
      "Our organisation understands the need to digitally combine and coordinate different elements needed for optimum service delivery.",
      "In our organisation, the right digital tools (e.g BIM) needed for the management of elements in the delivery of optimum services are known and plans are in place towards achieving a digitalised integrated service management system",
      "In our organisation, integrated service is managed using appropriately defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "Continuous improvement of the integrated service system is achieved through the effective use of digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_6",
    element_id: "process",
    variable_name: "Value delivery and quality management",
    question: "Which of the following statements regarding 'value delivery and quality management' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, value delivery and quality management is not digitalised",
      "Our organisation understand the need to digitalise its value delivery and quality management system, but the right tools needed are not completely known. ",
      "The digital tools needed to digitalise the value delivery and quality management system of our organisation are known, and plans are in place towards achieving this",
      "In our organisation, value delivery and quality are managed using appropriately defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "Continuous improvement of the digital management of  value delivery and quality is achieved through the effective use of digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_7",
    element_id: "process",
    variable_name: "Digitalised stakeholder management",
    question: "Which of the following statements regarding 'digitalised stakeholder management' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, the concept of digitally managing stakeholders is not clearly understood",
      "Our organisation understand the need to digitally manage its stakeholders, but the right tools needed are not completely known. ",
      "The digital tools needed to digitally manage stakeholders are known, and plans are in place towards achieving a digitalised stakeholder management system in our organisation",
      "In our organisation, stakeholders are managed using appropriately defined digital tools. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently.",
      "Continuous improvement of the digital management of stakeholders is achieved through the effective use of digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_8",
    element_id: "process",
    variable_name: "Digitalised scope management",
    question: "Which of the following statements regarding 'digitalised scope management' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, the management of project scope is not done digitally ",
      "Our organisation understand the need for a digitalised scope management, but the right tools needed are not completely known. ",
      "The digital tools needed for proper scope management are known, and plans are in place towards achieving a digitalised scope management system in our organisation",
      "In our organisation, project scope is managed using defined digital tools, and performance measurement of these tools is done consistently.",
      "Based on performance evaluation, continuous improvement of the project scope management is achieved through the effective use of digital digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_9",
    element_id: "process",
    variable_name: "Digitalised cost management process",
    question: "Which of the following statements regarding 'digitalised cost management process' best fit your organisation?",
    response: "",
    options: [
      "Traces of the use of cost estimating and management software can be found in our organisation. However, this is not with the aim of digitalising the whole construction process",
      "Our organisation understand the need for a digitalised cost management system, but consistency in the use of the right digital tools that can effectively help manage cost is absent. ",
      "The right technology needed for the management of cost is known , and plans are in place towards achieving a digitalised cost management system in our organisation",
      "In our organisation, cost is managed using clearly defined digital tools and the performance measurement of these toolss is done consistently.",
      "Based on performance evaluation, continuous improvement is achieved through the effective use of digital digital tools in our organisation",
    ],
  },

  {
    variable_id: "process_10",
    element_id: "process",
    variable_name: "Digitalised procurement process",
    question: "Which of the following statements regarding 'digitalised procurement process' best fit your organisation?",
    response: "",
    options: [
      "Our organisation still adopts the traditional procurement systems ",
      "There is a mixture of the use of e-procurement and the traditional approach in our organisation",
      "Our organisation has clearly defined policies on the use of e-procurement.",
      "In our organisation, resources are procured strictly using e-procurement approach. Continuous evaluation of the system is conducted for improvement",
      "Continuous improvement is achieved through the effective use of e-procurement in our organisation",
    ],
  },

  {
    variable_id: "process_11",
    element_id: "process",
    variable_name: "Digital risk management",
    question: "Which of the following statements regarding 'digital risk management' best fit your organisation?",
    response: "",
    options: [
      "Fear of unforeseen consequences of digitalisation serves as a barrier to the digital transformation of our organisation. ",
      "Our organisation understands the need to be prepared for unforeseen consequences of digitalising and we are willing to learn from past mistakes. ",
      "The right digital risk-mitigating measure to be adopted in the case of unforeseen problems is defined within our organisation ",
      "Digital risk is effectively managed using appropriate digital tools and continuous conducted in our organisation.",
      "Our organisation is continuously improving on its mitigating measures for unforeseen consequences of digitalisation of its services.",
    ],
  },

  {
    variable_id: "process_12",
    element_id: "process",
    variable_name: "Change management",
    question: "Which of the following statements regarding 'change management' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, changes are handled as they come along. ",
      "Our organisation learns from previous changes and are willing to adopt digital tools needed to ease the management of these changes.",
      "Our organisation sees the importance of change management and have the digital tools necessary to manage changes.",
      "Our organisation actively manage changes and build adaptive capacity through the strategic application of digital tools.",
      "Continuous improvement of change management within our organisation is evident.",
    ],
  },

  {
    variable_id: "process_13",
    element_id: "process",
    variable_name: "Communication management",
    question: "Which of the following statements regarding 'communication management' best fit your organisation?",
    response: "",
    options: [
      "Our organisation still adopts the traditional communication approaches",
      "Our organisation understand the need for a digitalised communication system",
      "The digital tools needed for effective communication are known, and plans are in place towards achieving a digitalised communication system in our organisation",
      "In our organisation, communication is managed using defined digital tools, and performance measurement of these tools is done consistently.",
      "Based on performance evaluation, continuous improvement of communication management is achieved through the effective use of digital digital tools in our organisation",
    ],
  },
  /////////begin strategy

  {
    variable_id: "strategy_1",
    element_id: "strategy",
    variable_name: "Research and development",
    question: "Which of the following statements regarding 'research and development' best fit your organisation?",
    response: "",
    options: [
      "Our organisation does not fund R&D",
      "The support for R&D in our organisation is low. ",
      "In our organsiation, the need for R&D is defined and plans towards achieving effective R&D are in place.",
      "In our organisation, R&D is a major source of decision making, hence considerable support is given to the process.",
      "Our organisation leads the construction industry discoruse on digital transformation due to its investment in R&D.",
    ],
  },

  {
    variable_id: "strategy_2",
    element_id: "strategy",
    variable_name: "Digital technology selection",
    question: "Which of the following statements regarding 'digital technology selection' best fit your organisation?",
    response: "",
    options: [
      "In our organisation the choice of the right digital technology to use is still fuzzy",
      "In our organisation, the the choice of the right digital technology to use is known and the selection is strictly a management function.",
      "Our organisation has guidelines for the selection of digital technologies and this selection is done based on input from both management and employees",
      "Our organisation continues to improve on its guidelines for digital technology selection through proper evaluation of the performance of already adopted technologies",
      "Our organisation understand the importance of being uptodate with the latest digital technology in the quest for digital transformation",
    ],
  },

  {
    variable_id: "strategy_3",
    element_id: "strategy",
    variable_name: "Forecasting client’s need",
    question: "Which of the following statements regarding 'forecasting client’s need' best fit your organisation?",
    response: "",
    options: [
      "Our organisatin deals with clients needs as they arise",
      "Our organisation understand the needs to forcast cleints needs using digital technologies, and are prepared to learn through series of repetitive processess.",
      "In our organisation, clients needs are forecasted using digital technologies",
      "Our organisation strives to continously improve its understanding of clients needs through the improvement of its adoption of digital technologies",
      "",
    ],
  },

  {
    variable_id: "strategy_4",
    element_id: "strategy",
    variable_name: "Project and service boundary",
    question: "Which of the following statements regarding 'project and service boundary' best fit your organisation?",
    response: "",
    options: [
      "Our organisation has no defined boundary for its project and services",
      "Our organisation understand the need for a clear boundary for its services and plans are being set to achieve this.",
      "Our organisation has been able to clearly set out boundaries for its projects and services in a bid to be specialised through the sue of defined digital technologies.",
      "Our organisation continues to use digital technology to improve on its servcies within the set boundaries. Guidelines for evaluating our organsiation's performance within this set area is clear.",
      "Our organisation is leading projects and service delivery within its defined space through the use of digital technology",
    ],
  },

  {
    variable_id: "strategy_5",
    element_id: "strategy",
    variable_name: "Clients' feedback evaluation",
    question: "Which of the following statements regarding 'clients' feedback evaluation' best fit your organisation?",
    response: "",
    options: [
      "",
      "Our organisation understand the need to carefully evaluate cleints' feedback using digital technologies, and are prepared to learn through series of repetitive processess.",
      "In our organisation, clients' feedback are carefully evaluated using digital technologies",
      "Our organisation strives to continously improve its services to its clients through the improvement of the evaluation of clients feedback using digital technologies",
      "",
    ],
  },

  {
    variable_id: "strategy_6",
    element_id: "strategy",
    variable_name: "Investment in digital technology",
    question: "Which of the following statements regarding 'investment in digital technology' best fit your organisation?",
    response: "",
    options: [
      "Our organisation cannot afford to invest on digital technologies at this stage",
      "Plans to invest on digital technologies is at an advance stage in our organisation",
      "Our organisation has implemented plans to invest in digiatl technologies",
      "Our organisation is continuously increasing its investment in digital technologies. Guidelines for the performance measurement of these tools are in place, and evaluation is done consistently. ",
      "Our organisation is a digital disruptor in the construction industry as investment in emerging technologies are continuous",
    ],
  },

  {
    variable_id: "strategy_7",
    element_id: "strategy",
    variable_name: "Decision-making procedure",
    question: "Which of the following statements regarding 'decision-making procedure' best fit your organisation?",
    response: "",
    options: [
      "In our organsiation, the decision-making procedure for digital tool deployment is slow ",
      "The decision-making for digital tool deployment is subject to the outcome of the previous adoption.",
      "In our organisation, decision-making procedure is rapid and its based on the outcomes from the use of digital tools",
      "Our organisation continues to improve in its decision making through effective use of digital tools",
      "",
    ],
  },

  {
    variable_id: "strategy_8",
    element_id: "strategy",
    variable_name: "Digitalised performance measurement",
    question: "Which of the following statements regarding 'digitalised performance measurement' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, performance measurement is not digitalised",
      "Our organisation plans on digitalising its performance measurement approach. ",
      "Performance measurement in our organisation is done through the use of digital tools. ",
      "Our continues to improve on its performance measurement through the use of digital tools and guidelines for improvement are in place.",
      "Ourorganisation continues to improve in its performance due to its continuous performance measurement done using digital tools.",
    ],
  },

  {
    variable_id: "strategy_9",
    element_id: "strategy",
    variable_name: "Information and communication management",
    question: "Which of the following statements regarding 'iInformation and communication management' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, there is no effective communication of digitalisation strategies ",
      "Information on digitalisation strategy is kept on a tight leash among top management in our organisation",
      "Digitalisation strategy is clearly defined and communicated to management and employees of our organisation",
      "In our organisation, digitalisation is properly communicated to all within the organisation and external actors (such as clients)",
      "Digital strategy to be adopted in constantly being improved upon through continuous adoption of emerging technologies in our organisation.",
    ],
  },

  {
    variable_id: "strategy_10",
    element_id: "strategy",
    variable_name: "Digital alignment of business",
    question: "Which of the following statements regarding 'digital alignment of business' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, the business goal is disjointed from the digital tools adopted",
      "There are some reservations regarding the  alignment of business with digitalisation in our organisation. ",
      "Our organisation have objectives towards aligning the business with the digitalisation in place.",
      "There is a technology-driven transparency through digital technology usage in our organisation. ",
      "Continuous improvement in aligning business goals with digitalisation is evident in our organisation",
    ],
  },

  {
    variable_id: "environment_1",
    element_id: "environment",

    variable_name: "Clients’ pressure",
    question: "Which of the following statements regarding 'client pressure' best fit your organisation?",
    response: "",
    options: [
      "Our organisation understands the importance of clients' pressure to adopt digital technologies, but the plans to adopt are still at the infancy stage.",
      "Our organisation understands the importance of client pressure to adopt digital technologies, and effort are being made to adopt digital technologies in deliverying servcies to our cleints",
      "A clear understanding of the ever-changing taste of clients in known, and the need to continuously implement emerging technologies to meet this demand is clearly defined in our organisation",
      "In our organisation, clients ever-changing desires are met with the adoption of emerging digital technologies needed to fulfil these desires. ",
      "In our organisation, there is continuous improvement in converting client’s pressure to adopt digital technologies into positive drive for innovativeness and digital transformation.",
    ],
  },

  {
    variable_id: "environment_2",
    element_id: "environment",
    variable_name: "Suppliers’ pressure",
    question: "Which of the following statements regarding 'supplier pressure' best fit your organisation?",
    response: "",
    options: [
      "Our organisation understands the importance of suppliers' pressure to adopt digital technologies, but plans to adopt are still at the infancy stage.",
      "Our organisation understands the importance of suppliers' pressure to adopt digital technologies, and effort are being made to ensure the adoption of digital technologies ",
      "Our organisation has a clear objective to continuously adopt emerging technologies as required by our uppliers.",
      "In our organisation, suppliers pressure are used as a positive drive to be innovative through proper digital technology deployment",
      "In our organisation, there is continuous improvement in converting suppliers' pressure to adopt digital technologies into positive drive for innovativeness and digital transformation.",
    ],
  },

  {
    variable_id: "environment_3",
    element_id: "environment",
    variable_name: "Competitors’ influence",
    question: "Which of the following statements regarding 'competitor influence' best fit your organisation?",
    response: "",
    options: [
      "Our organisation recognises that our competitors are adopting digtal technologies and plans to do the same is in progress",
      "Our organisation has put plans in place to adopt some digital technologies used by our competitors. ",
      "Our organisation has clearly defined objectives in digital technology usage in order to remain competitive within the construction industry.",
      "Our organisation is improving in its obejcetives to use digital technology in order to stay ahead of the comeptition within the construction industry.",
      "Our organisation is leading the deployment of  digital technology within the construction industry",
    ],
  },

  {
    variable_id: "environment_4",
    element_id: "environment",
    variable_name: "Government legislation",
    question: "Which of the following statements regarding 'government legislation' best fit your organisation?",
    response: "",
    options: [
      "",
      "Our organisation recognises the importance of government legislations on the deployment of digital tools for construction project delivery",
      "Our organisation adheres to the government legislations on the deployment of digital tools for construction project delivery",
      "Our organisation sees government legislation on the use of digital tools as a positive drive to be digitally transformed",
      "In our organisation, government legislations are continuously converted into a positive drive for adopting technologies",
    ],
  },

  {
    variable_id: "environment_5",
    element_id: "environment",
    variable_name: "Industry rules and regulations",
    question: "Which of the following statements regarding 'industry regulation' best fit your organisation?",
    response: "",
    options: [
      "",
      "Our organisation recognises the importance of industry rules and regulations on the deployment of digital tools for construction project delivery",
      "Our organisation adheres to the industry rules and regulations on the deployment of digital tools for construction project delivery",
      "Our organisation sees industry rules and regulations on the use of digital tools as a positive drive to be digitally transformed",
      "In our organisation, industry rules and regulations are continuously converted into a positive drive for adopting technologies",
    ],
  },

  {
    variable_id: "environment_6",
    element_id: "environment",
    variable_name: "Market scope",
    question: "Which of the following statements regarding 'market scope' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, the target market of does not infleunce our descision to be digitalised",
      "Our organisation understands the importance of its target market and plans to use it to shape its digital transformation",
      "In our organisation, there are clear objectives to align our digital transformation with our target market requirement",
      "Our organisation uses its market scope to shape our digital transformation and produce defined products for its target market",
      "In our organisation, there is continuous improvement in the use of our market scope in shaping our digital tramsformation.",
    ],
  },

  {
    variable_id: "environment_7",
    element_id: "environment",
    variable_name: "Environmental impact assessment",
    question: "Which of the following statements regarding 'environmental impact assessment' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, the environmental impact does not infleunce our descision to use digital technologies and innovative processes",
      "Our organisation recognises the importance of adopting digital technologies and processes that does harm the environment",
      "Our organisation have clearly defined objectives and policies on the use of digital technologies and processes that does not harm the environment",
      "Our organisation continues to improve on its objectives and plocies on the use of digital technologies and processes that does not harm the environment",
      "Our organisation is leading the deployment of  digital technologies that create no harm to the immediate environment",
    ],
  },

  //////begin digital partnering

  {
    variable_id: "digital_partnering_1",
    element_id: "digital_partnering",
    variable_name: "Digital partner selection",
    question: "Which of the following statements regarding 'digital partner selection' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, digital partnering is not considered",
      "Our organisation understands the need to partner, and are willing to learn from series of partnering relationships",
      "Our organisation have clearly defined list of organisations to partner withand their complementary digital capabilities are known to us.",
      "For our organisation, careful selection of digital partners is done from within and outside the construction industry",
      "In our organisation, there is a continuous improvement of the selection of potential partners for digital partnering relationship",
    ],
  },

  {
    variable_id: "digital_partnering_2",
    element_id: "digital_partnering",
    variable_name: "Top management support for digital partnering",
    question: "Which of the following statements regarding 'top management support' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, digital partnering is not considered",
      "Top management supports digital partnering and plans are at advanced stages to partner with other digital oriented organisations within and outside the industry.",
      "Top management has clear objectives and policies regarding digital partnering in our oragnsiation.",
      "Top management are continuosly improving on the objectives and policies for digital partnering in our organisation ",
      "Top management of my organisation are constantly seeking new organisations to partner up with in the quest for continuous digital transformation",
    ],
  },

  {
    variable_id: "digital_partnering_3",
    element_id: "digital_partnering",
    variable_name: "Long-term commitment to digital partnering",
    question: "Which of the following statements regarding 'long-term commitment' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, digital partnering is not considered",
      "Since our organisation is just beginning its digital transformation joruney, partnering with other organisation for this puprose is only on a short-term bases",
      "The intention to create a long-term commitment to the digital partnering relationship is clearly defined within our organisation",
      "In our organisation, digital partnering is strategic, and the emphasis is placed on achieving digital transformation in the long run.",
      "Continuous improvement in the long-term digital partnering relationship created.",
    ],
  },

  {
    variable_id: "digital_partnering_4",
    element_id: "digital_partnering",
    variable_name: "Conflict resolution in digital partnering",
    question: "Which of the following statements regarding 'conflict resolution' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, digital partnering is not considered",
      "Our organisation is still at the planning phase of digital partnering, and pricinples for conflict resoultion are still at the early stages of conceptualisation",
      "Our organisation has a clearly defined laid down conflict resolution approachfor digital partnering relationship.",
      "Our organisation ensures conflict resolution is positive with a win-win approach in the mind of all digital partners",
      "There is a continuous improvement in the conflict resolution approach adopted in the digital partnering relationship",
    ],
  },

  {
    variable_id: "digital_partnering_5",
    element_id: "digital_partnering",
    variable_name: "Trust in digital partners",
    question: "Which of the following statements regarding 'trust in digital partners' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, digital partnering is not considered",
      "Our organisation understands the for trust, and are willing to learn from series of partnering relationships",
      "Our organisation have clearly defined principles that will help build trust in the  complementary digital capabilities of our partners",
      "Our organisation trust in the digital capabilities of our partners.",
      "In our organisation, there is a continuous improvement of trust building principles and activities, to ensure improved digital partnering relationship. ",
    ],
  },

  {
    variable_id: "digital_partnering_6",
    element_id: "digital_partnering",
    variable_name: "Common goal in the partnering process",
    question: "Which of the following statements regarding 'common goal in the partnering process' best fit your organisation?",
    response: "",
    options: [
      "In our organisation, digital partnering is not considered",
      "Our organisation understands the the need to have common goals in every partnering relationship and are willing to learn from series of partnering relationships",
      "Our organisation have clearly defined goals to be achieved from every digital partnering relationship.",
      "Our organisation continue to improve on the set goals and align them with that of our partners in every digital partnering relationship",
      "In our organisation, there is a continuous strive for a common goal in digital partnering relationship",
    ],
  },
];

const ongoing_studies = [
  {
    name: "Chigozie Collins Okafor",
    topic: "AN INTEGRATED FRAMEWORK FOR SMART CITY DEVELOPMENT IN NIGERIA",
    year: 2021,
    abstract:
      "There is an urgent need for cities around the world to develop rapidly due to the current massive urbanization and population increase which have seen more than half of the world’s population (55%) living in cities around the globe. This number will increase to 66% in the year 2050, and will further increase to 80% by the end of the 21st century. This population expansion has been noted to be the cause of traffic congestion, environmental mismanagement, urban pollution, and scarcity of resources. This urban population expansion and its accompanying consequences is already a major developmental drawback factors in many developing economies of which Nigeria is a leading country. Empirical studies that evaluated and developed smart city models to enable cities to overcome these looming challenges are rare. Hence, this study develops an integrated framework for smart city development in Nigeria. This was achieved with a preliminary literature investigation which revealed that the concept of smart city is influenced by the exogenous variables’ smart economy, smart living, smart environment, smart governance, smart people, and smart mobility. Further review of previous model and theories of smart city revealed the following gaps (smart knowledge management and smart building regulation) which has not been accounted for in previous studies. An integrated framework was developed using the theoretical findings from previous literature and the Delphi survey results. The essence of the Delphi study was to validate the identified exogenous variables. The Delphi survey resulted to an expert led informed variables which was structured into a quantitative questionnaire for the development and validation of the developed integrated smart city framework. The findings of the study addressed the lack of theoretical information regarding which factors are the most influential in smart city development. Further findings were that the hypothesis could not be rejected. Hence, it was found that smart building regulation and smart knowledge management features and other exogenous variables, predicted smart city development. A confirmatory factor analysis was performed on the data obtained from the questionnaire survey. The findings revealed the hypothesis that the exogenous variables predicted the outcome of smart city development, and it could not be rejected. Furthermore, the statistical analysis which is the structural equation modelling revealed that the framework’s goodness of fit and the significance parameter estimate all met the recommended statistical cut off. This study has shown that the study of smart city is complex and dynamic, also that there are many factors that can influence its development. Furthermore, the government and policy makers should consider the results from this study while developing and introducing urban development policies, for the attainment of smart city.",
  },

  {
    name: "Rudzani Glen Muthelo ",
    topic: "A decision-making framework for evaluating public sector construction bids ",
    year: 2021,
  },

  {
    name: "Aloysius Sam ",
    topic: "A Framework for Leadership Development in the Ghanaian Constitution Industry ",
    year: 2023,
  },

  {
    name: "Ademilade Aboginije",
    topic:
      "Performance based-simulation and experimental investigation of deconstructable steel-concrete composite structures (A circularity and LCA Approach)",
    year: 2022,
  },

  {
    name: "Benjamen Sunkanmi Adeyemi",
    topic: "AN INTEGRATED CONFLICT MANAGEMENT MODEL FOR THE SOUTH AFRICAN CONSTRUCTION INDUSTRY",
    year: 2021,
  },

  {
    name: "Opeoluwa Akinradewo",
    topic: "DEVELOPMENT OF A BLOCKCHAIN-BASED INFORMATION MANAGEMENT SYSTEM FOR THE CONSTRUCTION INDUSTRY",
    year: 2022,
  },

  {
    name: "Tshepo Phuti Mabotja",
    topic: "SUPPLY CHAIN MANAGEMENT MODEL FOR THE SOUTH AFRICAN STEEL MANUFACTURING INDUSTRY IN THE ERA OF THE FOURTH INDUSTRIAL REVOLUTION",
    year: 2021,
  },

  {
    name: "David Ngwoke Mbazor",
    topic: "SUPPLY CHAIN MANAGEMENT MODEL FOR THE SOUTH AFRICAN STEEL MANUFACTURING INDUSTRY IN THE ERA OF THE FOURTH INDUSTRIAL REVOLUTION",
    year: 2022,
  },

  {
    name: "Mwewa Mambwe",
    topic: "Occupational Health and Safety Performance Management Framework for Small - Scale Electrical Contractors in Zambia",
    year: 2021,
  },
  {
    name: "Ifedolapo H. Babalola",
    topic: "A Human Resource Management Practice Model for Construction Industry in Nigeria",
    year: 2022,
  },

  {
    name: "Tlotlo K Ramasu",
    topic: "AN INTEGRATED FRAMEWORK FOR GROWTH OF FOOD MANUFACTURING SMALL AND MEDIUM ENTERPRISES (SMEs) IN BOTSWANA",
    year: 2021,
  },

  {
    name: "Khotso Dithebe",
    topic: "Maintenance management model for public office buildings in South Africa",
    year: 2022,
  },

  {
    name: "Linda Malifete",
    topic: "A new business model for the South African long term insurance in the era of the fourth industrial revolution",
    year: 2022,
  },

  {
    name: "Oluwaseun Tope Akinbogun",
    topic: "Framework for artisans in the Nigeria construction industry ",
    year: 2022,
  },

  {
    name: "Samuel Adeniyi Adekunle",
    topic: "BIM MATURITY MODEL FOR THE SOUTH AFRICAN CONSTRUCTION INDUSTRY",
    year: 2021,
  },

  {
    name: "Nomzamo",
    topic: "A framework for re-inventing the South Africa construction and building industry in the 21st century ",
    year: 2023,
  },

  {
    name: "Matthew Ikuabe",
    topic: "A Cyber-Physical Systems Adoption Model for Facilities Management in South Africa",
    year: 2021,
  },

  {
    name: "Olushola Akinshipe",
    topic: "A Digital Twin Model for Facility Management in South Africa",
    year: 2022,
  },

  // masters work starts here

  {
    name: "Peter A. Adekunle",
    topic: "Assessment of Construction Information Management in the South African Construction Industry ",
    year: 2021,
  },

  {
    name: "Sandile Mhlungu",
    topic: "An Assessment of the Integration of Mobile Technology into the Construction Management HEI Curriculum in South Africa ",
    year: 2021,
  },

  {
    name: "Olaoluwa O. Akinshipe",
    topic: "Design and Implementation of an Automated and Centralised Highway Road Lighting System",
    year: 2022,
  },
];

const phd_studies = [
  {
    name: "Dr. Emmanuel Yaw Frempong Jnr",
    topic: "Construction Waste Management Model for the Ghanaian Construction Industry. ",
    year: 2020,
  },

  {
    name: "Dr. Edward John Cobbina ",
    topic: "Framework for Sustainable Urban Transformation in Developing Countries ",
    year: 2020,
  },

  {
    name: "Dr. Olusegun Aanuoluwapo Oguntona",
    topic: "BIOMIMICRY SUSTAINABILITY ASSESSMENT TOOL FOR THE SOUTH AFRICAN CONSTRUCTION INDUSTRY",
    year: 2021,
  },

  {
    name: "Dr. John Aliu",
    topic: "AN EMPLOYABILITY IMPROVEMENT MODEL FOR BUILT ENVIRONMENT GRADUATES IN SOUTH AFRICA",
    year: 2020,
  },

  {
    name: "Dr. Temidayo Osunsanmi",
    topic: "INTEGRATED SUPPLY CHAIN MANAGEMENT MODEL FOR THE NIGERIAN CONSTRUCTION INDUSTRY",
    year: 2021,
  },

  {
    name: "Dr. Mpho Ndou",
    topic: "INDOOR AIR QUALITY MANAGEMENT MODEL FOR HIGHER EDUCATIONAL INSTITUTIONS IN SOUTH AFRICA",
    year: 2020,
  },
];

const masters_studies = [
  {
    name: "Dr. Edward John Cobbina ",
    topic: "Investigating the implementation of TQM in the construction industry in Ghana",
    year: 2012,
  },

  {
    name: "Opeoluwa Akinradewo",
    topic: "DEVELOPMENT OF A COST PROFILE FOR ROAD PROJECTS IN THE GHANAIAN CONSTRUCTION INDUSTRY",
    year: 2019,
  },

  {
    name: "Tlotlo K Ramasu",
    topic: "THE EFFECT OF TOC ADOPTION IN A SOUTH AFRICA: A CASE STUDY OF LONMIN MINE",
    year: 2018,
  },

  {
    name: "Linda Malifete",
    topic: "Assessing the impact of lean manufacturing in the South African airline industry",
    year: 2019,
  },

  {
    name: "John Aiyesehinde",
    topic: "Evaluating the Relationship Between Service Quality and Customer Satisfaction in the Automotive After-sale Service Sector",
    year: 2018,
  },

  {
    name: "Olushola Akinshipe",
    topic: "An Assessment of Sino-African Relations to the Growth of the Construction Industry: A Case Study of Nigeria",
    year: 2019,
  },
];

const journals = [
  {
    name: "Driving the 4IR initiative through university and industry collaborations. Journal of Construction in Developing Countries. ISSN: 2180-4222",
    aurthors: "Aliu, J. and Aigbavboa, C.O.,",
    year: 2021,
  },
  {
    name: "Key Generic Skills for Employability of Built Environment Graduates. International Journal of Construction Management Print ISSN: 1562-3599 Online ISSN: 2331-2327",
    aurthors: "Aliu, J. and Aigbavboa, C.O.,",
    year: "2021",
  },
  {
    name: "Unravelling the Risks of Digitalisation in the Construction Industry of Developing Countries. Construction Innovation, Emerald Publishers (In Press)",
    aurthors: "Aghimien, D. O, Aigbavboa, C. O, Meno, T., Ikuabe, M., ",
    year: "2021",
  },
  {
    name: "3D printing for Sustainable Low-income Housing in South Africa: A case for the Urban Poor. Journal of Green Building, College Publishing (In Press)",
    aurthors: "Aghimien, D. O, Aigbavboa, C. O, Aghimien, L.M., Thwala, W.D., and Ndlovu, L., ",
    year: "2021",
  },
  {
    name: "Measures for Adopting Lean Construction in the South African Construction Industry. International Journal of Productivity and Quality Management, Inderscience Publishers (In Press)",
    aurthors: "Ikuabe, M., Aghimien, D.O., Aigbavboa, C.O., Ramaru, P. Bolstering",
    year: "",
  },
  {
    name: " Dynamic Capabilities for Digitalisation in the AECO sector – A Scientometric Review, Engineering, Construction and Architectural Management, Ahead-of-print. DOI: https://doi.org/10.1108/ECAM-12-2020-1012",
    aurthors: "Aghimien, D. O, Aigbavboa, C. O, and Oke, A. E., Edward, D.J., Thwala, W.D., and Roberts, C. ",
    year: "2021",
  },
  {
    name: "Assessing South African Construction Worker’s Knowledge of Modern Technologies for Effective Material Management. Engineering Journal, 25(1), 137-142. DOI: 10.4186/ej.2021.25.1.137",
    aurthors: "Odubiyi, T.B., Aghimien, D.O., Oke, A. E., Aigbavboa, C. O., Thwala, W.D. ",
    year: "2021",
  },
  {
    name: "A Bibliometric Analysis and Visual Review of Housing Policy Framework Development Research. The Thinker 85(3), 51-62. ",
    aurthors: "Aigbavboa, C.O and Thwala, WD.",
    year: "2020",
  },
  {
    name: "Making a case for smart buildings in preventing coronavirus: focus on maintenance management challenges. International journal of construction management https://doi.org/10.1080/15623599.2020.1842960 ",
    aurthors: "Osunsanmi, T.O., Aigbavboa, C.O., Oke, A., Onyia, M.A. ",
    year: "2020",
  },
  {
    name: "Appraisal of stakeholder’s willingness to adopt construction 4.0 technologies for construction projects. Built Environment Project and Asset management 10(4), 547-565.",
    aurthors: "Osunsanmi, T.O., Oke, A. and Aigbavboa, C., ",
    year: "2020",
  },
  {
    name: "Major constraints of the Sino-African relations in the Nigerian construction industry’. Forum of Developmental Studies. 47:3, 469-488, DOI: 10.1080/08039410.2020.1778780",
    aurthors: "Akinshipe, O. and Aigbavboa, C.",
    year: "2020",
  },
  {
    name: "Mitigating Engineering Skills Deficiency in South Africa. Journal of Physics: Conference Series. (In-press)",
    aurthors: "Akinradewo O., Akinshipe O., Aigbavboa C., Maake M., Thwala W.D and Onyia M.",
    year: "2020",
  },
  {
    name: "Engineering Skills Shortage: A Bane to Better Performance in the Construction Industry. Journal of Physics: Conference Series. (In-press)",
    aurthors: "Akinshipe O., Akinradewo O., Aigbavboa C., Maake M., Thwala W.D and Onyia M. ",
    year: "2020",
  },
  {
    name: "The rationale for Sino-African relations in the construction industry: the case of Nigeria. Journal of Physics: Conference Series. (In-press)",
    aurthors: "Akinshipe O., Aigbavboa C., Thwala W.D.",
    year: "2020",
  },
  {
    name: "The rationale for Sino-African relations in the construction industry: the case of Nigeria. Journal of Physics: Conference Series. (In-press)",
    aurthors: "Akinshipe O., Oluleye I.B., Olukolajo M.A., Aigbavboa C., and Thwala W.D. ",
    year: "2020",
  },
  {
    name: "The preparedness of Nigerian built environment students towards delivering sustainable construction. Journal of Physics: Conference Series. (In-press)",
    aurthors: "Akinshipe O., Oluleye I.B., Olukolajo M.A., Aigbavboa C., and Thwala W.D.",
    year: "2020",
  },
  {
    name: "). Key emerging technologies transforming public transportation in the Fourth Industrial Revolution era. Journal of Physics: Conference Series. (In-press)",
    aurthors: "Mbowa K., Aigbavboa C., Akinshipe O., and Thwala W.D. ",
    year: "2020",
  },
  {
    name: "Latent Institutional Environment Factors influencing Construction Digitalization – International Journal of Construction Education and Research, Ahead-of-print, ISSN 1550-3984 DOI: 10.1080/15578771.2020.1838973 ",
    aurthors: "Aghimien, D. O, Aigbavboa, C. O, Oke, A. E., and Aghimien, L.M. ",
    year: "2020",
  },
  {
    name: "A fuzzy synthetic evaluation of the challenges of smart city development in developing countries. Smart and Sustainable Built Environment, Ahead-of-print, ISSN: 2046-6099 DOI: 10.1108/SASBE-06-2020-0092 ",
    aurthors: "Aghimien, D.O., Aigbavboa, C.O., Edwards, D.J., Mahamadu, A., Olomolaiye, P., Hazel, N., and Onyia, M. ",
    year: "2020",
  },
  {
    name: "). Factors Influencing the Adoption of Insurance as a Risk Treatment Tool by Contractors in the Construction Industry. International Journal of Construction Management. Ahead-of-print, ISSN 1562-3599 DOI: https://doi.org/10.1080/15623599.2020.1797986 ",
    aurthors: "Akinradewo, O., Aghimien, D. O, Aigbavboa, C.O., and Onyia, M.",
    year: "2020",
  },
  {
    name: "Improving Resilience of Cities through Smart City System. Construction Economics and Building, 20(2), 45-64, ISSN: 2204-9029 DOI: 10.5130/AJCEB.v20i2.6647 ",
    aurthors: "Oke, A.E., Aghimien, D.O., Akinradewo, O., Aigbavboa, C.O.",
    year: "2020",
  },
  {
    name: "Appraisal of the Drivers of Smart City Development in South Africa. Construction Economics and Building, 20(2)109-126, ISSN: 2204-9029 DOI: 10.5130/AJCEB.v20i2.6632 ",
    aurthors: "Oke, A.E., Aghimien, D.O., Aigbavboa, C.O., Akinradewo, O.",
    year: "2020",
  },
  {
    name: "Critical Success Factors for Digital Partnering in Construction Organisations. Engineering, Construction and Architectural Management, 27(10), 3171-3188, ISSN 0969-9988 DOI: 10.1108/ECAM-11-2019-0602",
    aurthors: "Aghimien, D. O, Aigbavboa, C.O., and Oke, A.E. ",
    year: "2020",
  },
  {
    name: "Digitalization of construction organizations – A case for digital partnering. International Journal of Construction Management. Ahead-of-print, ISSN 1562-3599 DOI: 10.1080/15623599.2020.1745134 ",
    aurthors: "Aghimien, D. O, Aigbavboa, C.O., Oke, A.E., Thwala, W.D., and Moripe, P.B. ",
    year: "2020",
  },
  {
    name: "Making a case for 3D printing for housing delivery in South Africa. International Journal of Housing Market and Analysis, 3(4), 565-581, ISSN 1753-8270 DOI: 10.1108/IJHMA-11-2019-0111 ",
    aurthors: "Aghimien, D. O, Aigbavboa, C.O., Aghimien, L.M., Thwala, W.D. and Ndlovu, L.",
    year: "2020",
  },
  {
    name: "Driving the 4IR initiative through university and industry collaborations. Journal of Construction in Developing Countries. ISSN: 2180-4222 ",
    aurthors: "Aliu, J. and Aigbavboa, C.O., ",
    year: "2020",
  },
  {
    name: "Structural determinants of graduate employability: Impact of university and industry collaborations. Journal of Engineering Design and Technology: Online ISSN: 1550-3984 ",
    aurthors: "Aliu, J. and Aigbavboa, C.O., ",
    year: "2020",
  },
  {
    name: "Mapping global research relating to the employability concept: A bibliometric review. Engineering, Construction and Architectural Management (Accepted).",
    aurthors: "Aliu, J. and Aigbavboa, C.O.,",
    year: "2020",
  },
  {
    name: ". Examining pedagogical approaches in developing employability skills: A Delphi approach. International Journal of Sustainable Construction Engineering and Technology ISSN: 2180-3242 e-ISSN: 2600-7959",
    aurthors: "Aliu, J. and Aigbavboa, C.O.,",
    year: "2020",
  },
  {
    name: "An appraisal of the adoption internet of things (IoT) elements for sustainable construction. Journal of Engineering, Design and Technology. ISSN: 1726-0531. https://doi.org/10.1108/JEDT-10-2019-0270 ",
    aurthors: "Arowoiya, V.A., Oke, A.E., Aigbavboa, C.O. and Aliu, J., ",
    year: "2020",
  },
  {
    name: "Employers’ perception of employability skills among built environment graduates. Journal of Engineering, Design and Technology. ISSN: 1726-0531. https://doi.org/10.1108/JEDT-06-2019-0162 ",
    aurthors: "Aliu, J. and Aigbavboa, C.O., ",
    year: "2019",
  },
  {
    name: "Journal of Physics: Conference Series, Volume 1378, Part 1 Examining the Roles of Human Capital Theory. What next for Construction Industry? https://doi.org/10.1088/1742-6596/1378/2/022057",
    aurthors: "Aliu, J. and Aigbavboa, C.O., ",
    year: "2019",
  },
  {
    name: "Making a case for 3D printing for housing delivery in South Africa. International Journal of Housing Market and Analysis. Ahead-of-print, ISSN 1753-8270",
    aurthors: "Aghimien, D. O, Aigbavboa, C.O., Aghimien, L.M., Thwala, W.D. and Ndlovu, L. ",
    year: "2020",
  },
  {
    name: "Impact of Contractors' Opportunism on Construction Project Transaction Costs: Construction Professionals' Perception, Journal of Financial Management of Property and Construction. (accepted, in press)",
    aurthors: "Ikuabe, M.O., Oke, A.E and Aigbavboa, C.O.",
    year: "2020",
  },
  {
    name: "Conflict factors investigation among construction professionals in Nigeria, Journal of Engineering, Design and Technology, Vol. ahead-of-print No. ahead-of-print. https://doi.org/10.1108/JEDT-08-2019-0210",
    aurthors: "Adeyemi, B. and Aigbavboa, C.",
    year: "2020",
  },
  {
    name: "Labour-Only Procurement - A Veritable Surviving Strategy for Contractors in a Challenging Economy. Journal of Engineering, Design and Technology, 17(2), 347-361, ISSN 1726-0531 DOI: 10.1108/JEDT-06-2017-0060 ",
    aurthors: "Awodele, O. A, Aghimien, D. O, Akinkunmi, O. G., and Aigbavboa, C.O. ",
    year: "2019",
  },
  {
    name: "). Performance of A Green Building's Indoor Environmental Quality on Building Occupants in South Africa. Journal of Green Building, 14(1), pp.131-148.",
    aurthors: "Aigbavboa, C.O. and Thwala, W.D., ",
    year: "2019",
  },
  {
    name: "'Microscoping the challenges of sustainable construction in developing countries', Journal of Engineering, Design and Technology, 17(6), pp. 1110-1128",
    aurthors: "Aghimien, D.O., Aigbavboa, C.O. and Thwala, W.D., ",
    year: "2019",
  },
  {
    name: "Labour-only procurement: A veritable surviving strategy for contractors in a challenging economy. Journal of Engineering, Design and Technology, 17(2), pp.347-361.",
    aurthors: "Awodele, O.A., Aghimien, D.O., Akinkunmi, O.G. and Aigbavboa, C.O., ",
    year: "2019",
  },
  {
    name: "Barriers to sustainable procurement in the Nigerian construction industry: an exploratory factor analysis. International Journal of Construction Management, pp.1-12.",
    aurthors: "Ogunsanya, O.A., Aigbavboa, C.O., Thwala, D.W. and Edwards, D.J.,",
    year: "2019",
  },
  {
    name: "Offsite construction: Developing a BIM-Based optimizer for assembly. Journal of cleaner production, 215, pp.1180-1190.",
    aurthors: "Gbadamosi, A.Q., Mahamadu, A.M., Oyedele, L.O., Akinade, O.O., Manu, P., Mahdjoubi, L. and Aigbavboa, C.,",
    year: "2019",
  },
  {
    name: "'Using neural network model to estimate the rental price of residential properties', Journal of Financial Management of Property and Construction, 24(2), pp. 217-230",
    aurthors: "Oshodi, O.S., Thwala, W.D., Odubiyi, T.B., Abidoye, R.B. and Aigbavboa, C.O.,",
    year: "2019",
  },
  {
    name: "Survey dataset on fusing RFID with mobile technology for efficient safety of construction professionals. Data in brief, 25, p.104290.",
    aurthors: "Osunsanmi, T.O., Oke, A.E. and Aigbavboa, C.O.,",
    year: "2019",
  },
  {
    name: "An assessment of the level of emotional intelligence attributes of undergraduate built environment students in developing countries. Industry and Higher Education, 33(2), pp.108-115.",
    aurthors: "Owusu-Manu, D., Edwards, D.J., Kukah, A.S., Pärn, E.A., El-Gohary, H. and Aigbavboa, C., ",
    year: "2019",
  },
  {
    name: "An assessment of the level of emotional intelligence attributes of undergraduate built environment students in developing countries. Industry and Higher Education, 33(2), pp.108-115.",
    aurthors: "Owusu-Manu, D., Edwards, D.J., Kukah, A.S., Pärn, E.A., El-Gohary, H. and Aigbavboa, C.,",
    year: "2019",
  },
  {
    name: "Barriers hindering biomimicry adoption and application in the construction industry. African Journal of Science, Technology, Innovation and Development, 11(3), pp.289-297.",
    aurthors: "Oguntona, O.A. and Aigbavboa, C.O., ",
    year: "2019",
  },
  {
    name: "Analysis of the outcome features of effective monitoring and evaluation in construction project delivery. Journal of Engineering, Design and Technology. 17(6), pp. 1192-1201",
    aurthors: "Tengan, C., Aigbavboa, C.O., Guribie, F. and Annor-Asubonteng, J., ",
    year: "2019",
  },
  {
    name: "Construct-it: A board game to enhance built environment students’ understanding of the property life cycle. Industry and Higher Education, 33(3), pp.186-197.",
    aurthors: "Hayhow, S., Parn, E.A., Edwards, D.J., Hosseini, M.R. and Aigbavboa, C.,",
    year: "2019",
  },
  {
    name: "Outsourcing as a strategy for facilities management provision in Nigerian universities. International Journal of Construction Management, 19(4), pp.281-290.",
    aurthors: "Ikediashi, D. and Aigbavboa, C., ",
    year: "2019",
  },
  {
    name: "Pension reforms, risk transfer and housing finance innovations. Journal of Housing and the Built Environment, 34(4), pp.1149-1167.",
    aurthors: "Donkor-Hyiaman, K.A., Pärn, E.A., Owusu-Manu, D., Edwards, D.J. and Aigbavboa, C., ",
    year: "2019",
  },
  {
    name: "An Investigation of the Factors Influencing Indoor Environmental Quality (IEQ) of Residential Buildings in Gauteng, South Africa. Periodica Polytechnica Architecture, 50(1), pp.81-88.",
    aurthors: "Dosumu, O.S. and Aigbavboa, C.O., ",
    year: "2019",
  },
  {
    name: "Nature of communication performance in non-traditional procurements in South Africa. Engineering, Construction and Architectural Management. 26(10), pp. 2264-2288",
    aurthors: "Kwofie, T.E., Aigbavboa, C.O. and Machethe, S.O., ",
    year: "2019",
  },
  {
    name: "Critical success factors militating against competitive advantage of indigenous construction firms in developing countries. African Journal of Science, Technology, Innovation and Development, pp.1-8.",
    aurthors: "Somiah, M.K., Aigbavboa, C.O. and Thwala, W.D., (2019",
    year: "2019",
  },
  {
    name: "Assessing Urban Households’ Willingness to Pay for Standalone Solar Photovoltaic Systems: A Case Study of Lagos, Nigeria. Journal of Sustainable Development of Energy, Water and Environment Systems, 7(3), pp.553-566.",
    aurthors: "Ugulu, A.I. and Aigbavboa, C.,",
    year: "2019",
  },
  {
    name: "A principal component analysis of monitoring and evaluation determinants for construction projects delivery in developing countries. International Journal of Productivity and Quality Management, 27(4), pp.420-434",
    aurthors: "Tengan, C. and Aigbavboa, C.,",
    year: "2019",
  },
  {
    name: "Communication performance challenges in PPP projects: cases of Ghana and South Africa. Built Environment Project and Asset Management.",
    aurthors: "Kwofie, T.E., Aigbavboa, C.O. and Thwala, W.D., ",
    year: "2019",
  },
  {
    name: "'Measures to improve the adoption of life cycle assessment in the South African construction industry', Journal of Engineering, Design and Technology, 17(7)",
    aurthors: "Kwofie, T.E., Aigbavboa, C.O. and Thwala, W.D.,",
    year: "2019",
  },
  {
    name: "An investigation of the barriers to the uptake of local materials in Africa: A literature review approach. African Journal of Science, Technology, Innovation and Development, pp.1-7.",
    aurthors: "Dosumu, O.S. and Aigbavboa, C.,",
    year: "2019",
  },
  {
    name: "Assessing clients’ satisfaction with the service quality of construction consultants in Lagos, Nigeria. African Journal of Science, Technology, Innovation and Development, 11(6), pp. 771-779.",
    aurthors: "Dosumu, O.S. and Aigbavboa, C., ",
    year: "2019",
  },
  {
    name: "Analysis on the perceived occurrence of challenges delaying the delivery of water infrastructure assets in South Africa. Journal of Engineering, Design and Technology, 17(3), pp.554-571.",
    aurthors: "Dithebe, K., Aigbavboa, C.O., Thwala, W.D. and Oke, A.E., ",
    year: "2019",
  },
  {
    name: "Factor analysis of critical success factors for water infrastructure projects delivered under public-private partnerships. Journal of Financial Management of Property and Construction.",
    aurthors: "Dithebe, K., Aigbavboa, C.O., Thwala, W.D. and Oke, A.E., ",
    year: "2019",
  },
  {
    name: "A survey of machine learning methods applied to anomaly detection on drinking-water quality data. Urban Water Journal, 16(3), pp.235-248.",
    aurthors: "Dogo, E.M., Nwulu, N.I., Twala, B. and Aigbavboa, C., ",
    year: "2019",
  },
  {
    name: "Comparative assessment of construction cost overruns: A case study of regional distribution in Ghana. African Journal of Science, Technology, Innovation and Development, pp.1-4.",
    aurthors: "Coffie, G.H. and Aigbavboa, C.O., ",
    year: "2019",
  },
  {
    name: "",
    aurthors: "",
    year: "2019",
  },
  {
    name: "Modelling construction completion cost in Ghana public sector building projects. Asian Journal of Civil Engineering, 20(7), pp.1063-1070.",
    aurthors: "Coffie, G.H., Aigbavboa, C.O. and Thwala, W.D.,",
    year: "2019",
  },
  {
    name: "'Employers’ perception of employability skills among built-environment graduates', Journal of Engineering, Design and Technology, 17(7)",
    aurthors: "Aliu, J. and Aigbavboa, C.O. ",
    year: "2019",
  },
  {
    name: "Survey dataset on fusing RFID with mobile technology for efficient safety of construction professionals. Data in brief, 25(19), 25-31. ",
    aurthors: "Osunsanmi, T.O., Aigbavboa, C. and Oke, A. ",
    year: "2019",
  },
  {
    name: "Construction 4.0: The future of the construction industry in South Africa. International journal of civil environmental engineering, 12(3), 150-156. ",
    aurthors: "Osunsanmi, T.O., Aigbavboa, C. and Oke, A. ",
    year: "2018",
  },
  {
    name: " Barriers to the Adoption of Value Management in Developing Countries. Engineering, Construction and Architectural Management, 25(7), 818-834 ISSN 0969-9988 DOI: 10.1108/ECAM-04-2017-0070 ",
    aurthors: "Aghimien, D. O., Oke, A. E. and Aigbavboa, C. O. ",
    year: "2018",
  },
  {
    name: "Building design for people with dementia: a case study of a UK care home. Facilities, 36(7/8), pp.349-368.",
    aurthors: "Fisher, L.H., Edwards, D.J., Pärn, E.A. and Aigbavboa, C.O., ",
    year: "2018",
  },
  {
    name: "Evaluation of UFPA quality assessment criteria for monitoring and evaluation system in the Ghanaian construction industry. African Journal of Science, Technology, Innovation and Development, 10(2), pp.177-181.",
    aurthors: "Tengan, C., Aigbavboa, C.O. and Oke, A.E., ",
    year: "2018",
  },
  {
    name: "The knowledge enablers of knowledge transfer: a study in the construction industries in Ghana. Journal of Engineering, Design and Technology, 16(2), pp.194-210.",
    aurthors: "Owusu-Manu, D.G., John Edwards, D., Pärn, E.A., Antwi-Afari, M.F. and Aigbavboa, C.,",
    year: "2018",
  },
  {
    name: "Exploratory factor analysis on drivers of firm’s growth among construction SMEs in Ghana. African Journal of Science, Technology, Innovation and Development, 10(1), pp.20-27.",
    aurthors: "Arthur-Aidoo, B.M., Aigbavboa, C.O. and Thwala, W.D.,",
    year: "2018",
  },
  {
    name: "Causal relationships of moral hazard and adverse selection of Ghanaian Public-Private-Partnership (PPP) construction projects. Journal of Engineering, Design and Technology, 16(3), pp.439-460.",
    aurthors: "Owusu-Manu, D.G., Kukah, A.S., Edwards, D.J., Pärn, E.A., El-Gohary, H. and Aigbavboa, C., ",
    year: "2018",
  },
  {
    name: "Evaluation of vehicle light weighting to reduce greenhouse gas emissions with focus on magnesium substitution. Journal of Engineering, Design and Technology, 16(6), pp.869-888.",
    aurthors: "Kulkarni, S., Edwards, D.J., Parn, E.A., Chapman, C., Aigbavboa, C.O. and Cornish, R., ",
    year: "2018",
  },
  {
    name: "Ontology of the Communication Performance prospects of BIM Adoption among Project Teams in Construction Project Delivery. Journal of Construction in Developing Countries, 24(2), pp1-28",
    aurthors: "Kwofie, T, Aigbavboa, C, and Baiden-Amissah, ",
    year: "2018",
  },
  {
    name: "Digitalizing asset management: concomitant benefits and persistent challenges. International Journal of Building Pathology and Adaptation, 36(2), pp.152-173.",
    aurthors: "Roberts, C.J., Pärn, E.A., Edwards, D.J. and Aigbavboa, C., ",
    year: "2018",
  },
  {
    name: "Dimensions of social barriers to effective collaborative working in construction supply chain. International Journal of Project Organisation and Management, 10(1), pp.37-53.",
    aurthors: "Kwofie, T.E., Aigbavboa, C.O. and Matsane, Z.S.S.,",
    year: "2018",
  },
  {
    name: "Improving continuing professional development compliance among construction professionals through integrated strategies in South Africa. Journal of Engineering, Design and Technology, 16(4), pp.637-653.",
    aurthors: "Kwofie, T.E., Aigbavboa, C.O. and Mpambela, J.S.,",
    year: "2018",
  },
  {
    name: "An assessment of the causes, cost effects and solutions to design-error induced variations on selected building projects in Nigeria. Acta Structilia, 25(1), pp.40-70.",
    aurthors: "Dosumu, O. and Aigbavboa, C., ",
    year: "2018",
  },
  {
    name: "Adoption of light steel (LS) for building projects in South Africa. Journal of Engineering, Design and Technology, 16(5), pp.711-733.",
    aurthors: "Dosumu, O. and Aigbavboa, C.O., ",
    year: "2018",
  },
  {
    name: "Blockchain 3.0: Towards a Secure Ballot coin Democracy through a Digitized Public Ledger in Developing Countries. i-Manager's Journal on Digital Signal Processing, 6(2), pp.1-24.",
    aurthors: "Dogo, E.M., Nwulu, N.I., Olaniyi, O.M., Aigbavboa, C.O. and Nkonyana, T.,",
    year: "2018",
  },
  {
    name: "An Examination of the Key Drivers of Amendments to the Standard Forms of Contract in the South African Construction Industry. Journal of Construction in Developing Countries, 23(1), pp.115-124.",
    aurthors: "Mewomo, M.C., Aigbavboa, C.O. and Lesailane, P.,",
    year: "2018",
  },
  {
    name: "The efficacy of using data mining techniques in predicting academic performance of architecture students. Journal of Engineering, Design and Technology, 16(2).",
    aurthors: "Aluko, R., Daniel, E., Oshodi, O. and Aigbavboa, C., ",
    year: "2018",
  },
  {
    name: "The efficacy of using data mining techniques in predicting academic performance of architecture students. Journal of Engineering, Design and Technology, 16(2).",
    aurthors: "Aluko, R., Daniel, E., Oshodi, O. and Aigbavboa, C.,",
    year: "2018",
  },
  {
    name: "Barriers to the adoption of value management in developing countries. Engineering, Construction and Architectural Management, 25(7), pp.818-834.",
    aurthors: "Aghimien, D.O., Oke, A.E. and Aigbavboa, C.O., ",
    year: "2018",
  },
  {
    name: "Validating factors influencing monitoring and evaluation in the Ghanaian construction industry: a Delphi study approach. International Journal of Construction Management, pp.1-12.",
    aurthors: "Tengan, C. and Aigbavboa, C., ",
    year: "2018",
  },
  {
    name: "Students’ satisfaction with hostel accommodations in higher education institutions. Journal of Engineering, Design and Technology, 15(5), pp.652-666.",
    aurthors: "Oke, A.E., Aigbavboa, C.O. and Raphiri, M.M., ",
    year: "2017",
  },
  {
    name: "Collaborative practices in South African construction project delivery. International Journal of Construction Supply Chain Management 7(2), pp. 39-55. doi: 10.14424/ijcscm70(2017)-39-55",
    aurthors: "Kwofie, T.E., Aigbavboa, C.O. and Matsane, Z.S.S.,",
    year: "2017",
  },
  {
    name: "Site Meeting as a Sustainable Construction Tool. Socioeconomica, 5(9), pp.83-92.",
    aurthors: "Oke, A., Mavimbele, B. and Aigbavboa, C., ",
    year: "2016",
  },
  {
    name: "'Critical Success Factors for Enhanced Stakeholder Management in Ghana'. Socioeconomica 5(10), pp. 153-170",
    aurthors: "Eyiah-Botwe, E, Aigbavboa, C.O., and Thwala, W.D.,",
    year: "2017",
  },
  {
    name: "'Implementation of Skill Development Act in The South African Construction Industry. Socioeconomica 5(9) pp 53-64",
    aurthors: "Aigbavboa, C, Ayodeji, E Oke, and Mpho, D Mokasha ",
    year: "2016",
  },
  {
    name: "Assessing beneficiaries’ needs and expectations as a determinant of residential satisfaction in South Africa. Housing, Care and Support, 19(1), pp.10-22.",
    aurthors: "Aigbavboa, C.,",
    year: "2016",
  },
  {
    name: "'A notional appraisal of the bases of housing satisfaction', International Journal for Housing Science and Its Applications, 40(2). pp. 133-145.",
    aurthors: "Aigbavboa, C.O. and Thwala, W.D., ",
    year: "2016",
  },
  {
    name: "Promoting biomimetic materials for a sustainable construction industry. Bioinspired, Biomimetic and Nanobiomaterials, 6(3), pp.122-130.",
    aurthors: "Oguntona, O.A. and Aigbavboa, C.O., ",
    year: "2016",
  },
  {
    name: "Geographical Diversity and Students’ Housing Satisfaction in South Africa. Socioeconomica, 4(8), pp.449-460.",
    aurthors: "Aigbavboa, C.O.,",
    year: "2015",
  },
  {
    name: "Operationalizing Sustainable Residential Development in Ghana: Consumer Attitudes Toward Willingness-To-Pay For Sustainable Alternatives'. Socioeconomica, 4(7), pp. 53-66",
    aurthors: "Ametepey, SO, and Aigbavboa, C.O., ",
    year: "2015",
  },
  {
    name: "), 'An Assessment of The Critical Factors Impeding the Delivery of Low-Income Housing in South Africa'. Socioeconomica, 3(6), pp. 219-232",
    aurthors: "Aigbavboa, C.O., ",
    year: "2014",
  },
  {
    name: "Structural equation modelling of building quality constructs as a predictor of satisfaction in subsidized low-income housing. Urbani Izziv, volume 25, supplement, 2014 (special issue), DOI: 10.5379/urbani-izziv-en-2014-25-supplement-00X",
    aurthors: "Aigbavboa, C.O. & Thwala, W.D.",
    year: "2014",
  },
  {
    name: " Lessons learned from in situ upgrading and eradication of informal settlement in Gauteng Province in South Africa, International Journal of Housing Markets and Analysis, 3(3): 233 – 244",
    aurthors: "Aigbavboa, CO and Thwala, WD.",
    year: "2010",
  },
];
const books = [
  {
    name: "A 21st Century Employability Skills Improvement Framework for the Construction Industry. London: Routledge.",
    aurthors: "Aliu, J., Aigbavboa, CO., and Thwala, WD., ",
    year: 2021,
    url: "https://www.routledge.com/A-21st-Century-Employability-Skills-Improvement-Framework-for-the-Construction/Aliu-Aigbavboa-Thwala/p/book/9780367684013",
  },
  {
    name: "Construction Project Monitoring and Evaluation- An Integrated Approach. London: Routledge.",
    aurthors: "Tengan, C., Aigbavboa, CO., and Thwala, WD.",
    year: "2021",
    url: "https://www.routledge.com/Construction-Project-Monitoring-and-Evaluation-An-Integrated-Approach/Tengan-Aigbavboa-Thwala/p/book/9780367685294",
  },
  {
    name: "Construction Digitalisation- A capability maturity Model for Construction Organisations. London: Routledge.",
    aurthors: "Aghimien, D., Aigbavboa, CO., Oke, E., and Thwala, WD ",
    year: "2021",
    url: "https://www.routledge.com/Construction-Digitalisation-A-Capability-Maturity-Model-for-Construction/Aghimien-Aigbavboa-Oke-Thwala/p/book/9780367758547",
  },
  {
    name: " Developing the Competitive Advantage of Indigenous Construction Firms. London: Routledge.",
    aurthors: "Somiah, MK., Aigbavboa, CO and Thwala, WD",
    year: "2021",
    url: "https://www.routledge.com/Developing-the-Competitive-Advantage-of-Indigenous-Construction-Firms/Somiah-Aigbavboa-Thwala/p/book/9780367705930",
  },
  {
    name: " Sustainable Construction in the Era of the Fourth Industry Revolution. London: Routledge.",
    aurthors: "Oke, A., Segun, S., Aigbavboa, CO., and Thwala, WD ",
    year: "2021",
    url: "https://www.routledge.com/Sustainable-Construction-in-the-Era-of-the-Fourth-Industrial-Revolution/Oke-Segun-Aigbavboa-Thwala/p/book/9781032012155",
  },
  {
    name: "Effective Construction Project Delivery - Improving Communication Performance in Non-Traditional Procurement Systems. Springer Nature Switzerland AG",
    aurthors: "Kwofie, TE, Aigbavboa, CO, Thwala, W. ",
    year: "2020",
    url: "https://www.springer.com/gp/book/9783030493738",
  },
  {
    name: "Modelling the Socio-Economic Implications of Sustainability Issues in the Housing Market- A Stated Choice Experimental Approach. Springer Nature Switzerland AG",
    aurthors: "Akinbogun, S.P., Aigbavboa, C., Gumbo, T., Thwala, W. ",
    year: "2020",
    url: "https://www.springer.com/gp/book/9783030489533",
  },
  {
    name: "Sustainable Design and Construction in Africa. London: Routledge.",
    aurthors: "Dosumu, O., Aigbavboa, CO. ",
    year: "2019",
    url: "https://www.crcpress.com/Sustainable-Design-and-Construction-in-Africa-A-System-Dynamics-Approach/Dosumu-Aigbavboa/p/book/9780815380795",
  },
  {
    name: "Residential Satisfaction and Housing Policy Evolution. London: Routledge",
    aurthors: "Aigbavboa, CO and Thwala, W.",
    year: "2018",
    url: "https://www.crcpress.com/Residential-Satisfaction-and-Housing-Policy-Evolution/Aigbavboa-Thwala/p/book/9781138500310",
  },
  {
    name: "Simulation-Based Analysis of Energy and Carbon Emissions in the Housing Sector. Green Energy and Technology. Springer, Cham",
    aurthors: "Oladokun MG., Aigbavboa CO ",
    year: "2018",
    url: "https://www.springer.com/gp/book/9783319753454",
  },
  {
    name: "Contractor Health and Safety Compliance for Small to Medium-Sized Construction Companies. Boca Raton: CRC Press.",
    aurthors: "Mustapha, Z., Aigbavboa, C., Thwala, W.",
    year: "2018",
    url: "https://www.crcpress.com/Contractor-Health-and-Safety-Compliance-for-Small-to-Medium-Sized-Construction/Mustapha-Aigbavboa-Thwala/p/book/9781138081550",
  },
  {
    name: "Sustainable Value Management for Construction Projects. Springer, Cham",
    aurthors: "Oke, AE., Aigbavboa CO ",
    year: "2017",
    url: "https://www.springer.com/gp/book/9783319541501",
  },
];
const book_chapters = [
  {
    name: "Unearthing the Factors Impeding Sustainable Construction in Developing Countries—A PLS-SEM Approach. Chapter 8 In: Howlett R.J., Littlewood J.R., Jain L.C. (eds) Emerging Research in Sustainable Energy and Buildings for a Low-Carbon Future. Advances in Sustainability Science and Technology. Springer, Singapore pp.113 – 134. https://0-doi-org.ujlink.uj.ac.za/10.1007/978-981-15-8775-7_8 ",
    aurthors: "Aghimien D., Aigbavboa C., Aghimien L., Oke A., Thwala W. ",
    year: "2021",
  },
  {
    name: "Barriers to the Adoption of Zero-Carbon Emissions in Buildings: The South African Narrative. Chapter 9 In: Howlett R.J., Littlewood J.R., Jain L.C. (eds) Emerging Research in Sustainable Energy and Buildings for a Low-Carbon Future. Advances in Sustainability Science and Technology. Springer, Singapore, pp.135-148 https://0-doi-org.ujlink.uj.ac.za/10.1007/978-981-15-8775-7_9)",
    aurthors: "Ikuabe M., Aghimien D., Aigbavboa C., Oke A., Ngaj Y. ",
    year: "2021",
  },
  {
    name: "Sustainable Road Infrastructure in Rural Areas in South Africa—A Preliminary Study. Chapter 20, In: Howlett R.J., Littlewood J.R., Jain L.C. (eds) Emerging Research in Sustainable Energy and Buildings for a Low-Carbon Future. Advances in Sustainability Science and Technology. Springer, Singapore, pp.331-338 https://0-doi-org.ujlink.uj.ac.za/10.1007/978-981-15-8775-7_20",
    aurthors: "Ikuabe M., Aghimien D., Aigbavboa C., Oke A",
    year: "2021",
  },
  {
    name: "Impediments of the Fourth Industrial Revolution in the South African Construction Industry. In: Ahmed S.M., Hampton P., Azhar S., D. Saul A. (eds) Collaboration and Integration in Construction, Engineering, Management and Technology. Advances in Science, Technology & Innovation (IEREK Interdisciplinary Series for Sustainable Development). Springer, Cham, pp.223-227. https://0-doi-org.ujlink.uj.ac.za/10.1007/978-3-030-48465-1_37",
    aurthors: "Aghimien D., Aigbavboa C., and Matabane K. ",
    year: "2021",
  },
  {
    name: " Environmental Sustainability: Impact of Construction Activities. In: Ahmed S.M., Hampton P., Azhar S., D. Saul A. (eds) Collaboration and Integration in Construction, Engineering, Management and Technology. Advances in Science, Technology & Innovation (IEREK Interdisciplinary Series for Sustainable Development). Springer, Cham, pp.229-234 https://0-doi-org.ujlink.uj.ac.za/10.1007/978-3-030-48465-1_38",
    aurthors: "Oke A., Aghimien D., Aigbavboa C., Madonsela Z. ",
    year: "2021",
  },
  {
    name: "Examining undergraduate courses relevant to the built environment in the 4IR era: a Delphi study approach. ‘Advances in Sustainability Science and Technology (ASST)' Springer book series entitled 'Emerging Research in Sustainable Energy, Buildings, Design and Manufacturing'",
    aurthors: "Aliu, J. and Aigbavboa, C.O., Ayodeji O., ",
    year: "2021",
  },
  {
    name: "Project Management in South Africa. Building a Body of Knowledge in Project Management in Developing Countries- a Book in The World Scientific Book Series on Domain-Specific Bodies of Knowledge in Project Management (Submitted for publication)",
    aurthors: "Aigbavboa, C., Aliu, J. and Thwala, WD,",
    year: "2021",
  },
  {
    name: "Examining undergraduate courses relevant to the built environment in the 4IR era: a Delphi study approach. ‘Advances in Sustainability Science and Technology (ASST)' Springer book series entitled 'Emerging Research in Sustainable Energy, Buildings, Design and Manufacturing'. (Accepted)",
    aurthors: "Aliu, J. and Aigbavboa, C.O., Ayodeji O., ",
    year: "2020",
  },
  {
    name: "Upscaling construction education: The role of construction site experiential learning. Part of the Advances in Intelligent Systems and Computing book series (AISC, volume 785). DOI:10.1007/978-3-319-93882-0_45",
    aurthors: "Aliu, J. and Aigbavboa, C.O., ",
    year: "2018",
  },
  {
    name: "Unearthing the factors impeding sustainable construction in developing countries – a PLS-SEM approach. Emerging Research in Sustainable Energy and Buildings for a Low-Carbon Future, Springer book series (In Press)",
    aurthors: "Aghimien, D.O., Aigbavboa, C.O., Aghimien, L.M., Oke, A.E., Thwala, W.D. ",
    year: "2020",
  },
  {
    name: "Upscaling construction education: The role of construction site experiential learning. Part of the Advances in Intelligent Systems and Computing book series (AISC, volume 785). DOI:10.1007/978-3-319-93882-0_45",
    aurthors: "Aliu, J. and Aigbavboa, C.O., ",
    year: "2018",
  },
  {
    name: "Unearthing the factors impeding sustainable construction in developing countries – a PLS-SEM approach. Emerging Research in Sustainable Energy and Buildings for a Low-Carbon Future, Springer book series (In Press) ",
    aurthors: "Aghimien, D.O., Aigbavboa, C.O., Aghimien, L.M., Oke, A.E., Thwala, W.D. ",
    year: "2020",
  },
  {
    name: " Sustainable Road Infrastructure in Rural Areas in South Africa - A Preliminary Study. Emerging Research in Sustainable Energy and Buildings for a Low-Carbon Future, Springer book series (In Press) ",
    aurthors: "Ikuabe, M.O., Aghimien, D.O., Aigbavboa, C.O., and Oke, A.E. ",
    year: "2020",
  },
  {
    name: "Barriers to the Adoption of Zero Carbon Emissions in Buildings: The South African Narrative. Emerging Research in Sustainable Energy and Buildings for a Low-Carbon Future, Springer book series (In Press) ",
    aurthors: "Ikuabe, M.O., Aghimien, D.O., Aigbavboa, C.O., Oke, A.E., and Ngaj, Y.",
    year: "2020",
  },
  {
    name: "Improving Sustainable Construction Practices through Facilities Management, in J. Calautit et al. (eds.), Towards Sustainable Cities in Asia and the Middle East, GeoMEast 2017, Sustainable Civil Infrastructures, Springer International Publishing, Switzerland, pp. 30-39 ",
    aurthors: "Aigbavboa CO, Oke AE and Edward LD",
    year: "2017",
  },
  {
    name: "Implementing Tilt-up Method for Sustainable Construction, in J. Calautit et al. (eds.), Towards Sustainable Cities in Asia and the Middle East, GeoMEast 2017, Sustainable Civil Infrastructures, Springer International Publishing, Switzerland, pp. 40-46 ",
    aurthors: "Oke AE, Aigbavboa CO and Yongama LT ",
    year: "2017",
  },
  {
    name: "Importance of Safety Guidelines on South African Construction Sites. In: Arezes P. (eds) Advances in Safety Management and Human Factors, AHFE 2017, Advances in Intelligent Systems and Computing, vol. 604. Springer, Cham, pp. 152-160 ",
    aurthors: "Oke A, Aigbavboa C and Seemola M. ",
    year: "2017",
  },
  {
    name: "Effect of Skills Shortage on Sustainable Construction. In: Charytonowicz J. (eds) Advances in Human Factors, Sustainable Urban Planning, and Infrastructure, AHFE 2017, Advances in Intelligent Systems and Computing, vol. 600. Springer, Cham, pp. 303-309 ",
    aurthors: "Oke A, Aigbavboa C, and Khangale T ",
    year: "2017",
  },
  {
    name: " Evaluation of procurement system of public funded projects, in Chau KW et al. (eds.), Proceedings of 21st CRIOCM international conference on Advancement of Construction management and Real Estate, (Chapter 64) held at Department of Real Estate and Construction, Faculty of Architecture, University of Hong Kong, 14-17 December, 2016, Springer International Publishing , Pp. 709-715 ",
    aurthors: "Oke, A. E., Aigbavboa, C. O. and Tony, B. A.",
    year: "2018",
  },
  {
    name: "Improving mentoring relationship of construction management professionals, in Chau KW et al. (eds.), Proceedings of 21st CRIOCM international conference on Advancement of Construction management and Real Estate, (Chapter 81) held at Department of Real Estate and Construction, Faculty of Architecture, University of Hong Kong, 14-17 December, 2016, Springer International Publishing, Pp. 899-905 ",
    aurthors: "Oke, A. E., Aigbavboa, C. O. and Mutshaeni, M. M",
    year: "2018",
  },
  {
    name: "Impacts of nanotechnology adoption on sustainable construction, in B. Fatahi et al. (eds.), Sustainable Design and Construction for Geomaterials and Geostructures, Sustainable Civil Infrastructures, Springer International Publishing, Pp. 286-293 ",
    aurthors: "Oke AE, Aigbavboa CO and Semenya K ",
    year: "2019",
  },
  {
    name: "Importance of indoor environmental quality criteria to occupants of low-income housing, in S. Shu et al. (eds.), New Developments in Materials for Infrastructure Sustainability and the Contemporary Issues in Geo-environmental Engineering, Sustainable Civil Infrastructures, Springer International Publishing, Pp. 247-256 ",
    aurthors: "Oke AE, Aigbavboa CO and Ngema NW ",
    year: "2019",
  },
  {
    name: "Construction Professionals Perception of Solid Waste Management in the South African Construction Industry. In Charytonowicz J and Falcão C. (eds.), 9th International Conference on Applied Human Factors and Ergonomics, 21-25 July 2018, Loews Sapphire Falls Resort, Universal Studios Orlando, Florida, United States of America, Springer International Publishing, pp. 496–505, 2019 ",
    aurthors: "Oke, A. E., Aigbavboa, C. O, Aghimien, D. O, and Nkululeko Currie ",
    year: "2019",
  },
  {
    name: "Barriers of Building Maintenance in Private Tertiary Institutions in Nigeria. In Charytonowicz J and Falcão C. (eds.), 9th International Conference on Applied Human Factors and Ergonomics, 21-25 July 2018, Loews Sapphire Falls Resort, Universal Studios Orlando, Florida, United States of America, Springer International Publishing, pp. 312–323 ",
    aurthors: "Aghimien, D. O, Oke, A. E. and Aigbavboa, C. O, ",
    year: "2019",
  },
  {
    name: "Utilization of Project Management Tools for Construction Project Success. In: Shehata M., Rodrigues F. (eds) Project Management and BIM for Sustainable Modern Cities. GeoMEast 2018. Sustainable Civil Infrastructures. Springer, Cham, pp 190-195 ",
    aurthors: "Gogela S., Oke A.E., Aigbavboa C.O. ",
    year: "2019",
  },
  {
    name: "Perception of Consultants and Contractors to Performance Factors of Construction Projects. In: Shehata M., Rodrigues F. (eds) Project Management and BIM for Sustainable Modern Cities. GeoMEast 2018. Sustainable Civil Infrastructures. Springer, Cham, pp 179-189 ",
    aurthors: "Oke A.E., Aigbavboa C.O., Mohapeloa K.",
    year: "2019",
  },
  {
    name: "Socio-economic Issues of Non-Conformance to Quality in Low-Income Housing Projects in South Africa. In Urban Crisis and Management in Africa; A Festschrift for Prof. Akin Mabogunje. Edited by Isaac Olawale Albert and Taibat Lawanson. Pan-African University Press, Austin, TX, USA",
    aurthors: "Aigbavboa, C., and Oke, A., ",
    year: "2019",
  },
  {
    name: "Green Finance for Sustainable Global Growth: Costs and Benefits of Green Buildings Compared with Conventional Buildings. In Green Finance for Sustainable Global Growth (pp. 244-269). IGI Global.",
    aurthors: "Ojo-Fafore, E.M., Aigbavboa, C., Thwala, W.D., and Ramaru, P.,",
    year: "2019",
  },
  {
    name: "Biomimicry Approaches for Innovative Sustainable Solutions in the Construction Industry. Innovative Production and Construction: Transforming Construction Through Emerging Technologies, p.335.",
    aurthors: "Oguntona, O.A. and Aigbavboa, C.O., ",
    year: "2019",
  },
  {
    name: "Introduction of construction experience to the classroom: What approaches should be adopted. In International Symposium on Emerging Technologies for Education (pp. 284-294). Springer, Cham. (LNCS, volume 10676).",
    aurthors: "Aliu, J. and Aigbavboa, C., ",
    year: "2018",
  },
  {
    name: "Indicative drivers of construction job insecurity in South Africa. In Valuing People in Construction (pp. 98-110). Routledge.",
    aurthors: "Aigbavboa, C.O. and Mathebula, L.,",
    year: "2017",
  },
  {
    name: "December. Lean Manufacturing: A case study with Kanban System implementation in Small and Medium Enterprise Manufacturing Companies in Nigeria. In (2017)-Sustainable Industrial Processing Summit (Vol. 7, pp. 190-195). Flogen Star Outreach.",
    aurthors: "Ohiomah, I. and Aigbavboa, C., ",
    year: "2017",
  },
  {
    name: "'Green Concrete as A Useful Resource in Low-Cost Rural Housing and Development'. In (2015)-Sustainable Industrial Processing Summit (Vol. 11, pp. 81-90). Flogen Star Outreach.",
    aurthors: "Agbenyeku, E, and Aigbavboa, C.O., ",
    year: "2016",
  },
  {
    name: "Contributory Factors of Students Satisfaction When Undertaking Group Work, a South Africa Higher Institution Case Study: Factors of Satisfaction When Undertaking Group Work. In Handbook of Research on Quality Assurance and Value Management in Higher Education (pp. 362-376). IGI Global.",
    aurthors: "Aigbavboa, C.O. and Thwala, W., ",
    year: "2016",
  },
  {
    name: "Improving Construction Supply Chains through Collaborative Modelling, a case of South Africa: Construction Supply Chain and Collaboration Modelling. In Supply Chain Strategies and the Engineer-to-Order Approach (pp. 61-75). IGI Global.",
    aurthors: "Aigbavboa, C., Masemeni, N.M. and Thwala, W., ",
    year: "2016",
  },
  {
    name: "Lean Manufacturing Adoption and Implementation in Nigeria Manufacturing Industries. In (2015)-Sustainable Industrial Processing Summit (Vol. 11, pp. 385-390). Flogen Star Outreach.",
    aurthors: "Aigbavboa, C.O. and Ohiomah, I.,",
    year: "2015",
  },
  {
    name: "Lean Manufacturing Adoption and Implementation in Nigeria Manufacturing Industries. In (2015)-Sustainable Industrial Processing Summit (Vol. 11, pp. 385-390). Flogen Star Outreach.",
    aurthors: "Aigbavboa, C.O. and Ohiomah, I., ",
    year: "2015",
  },
  {
    name: "A case study of Johannesburg and Tshwane metropolitan municipalities. The Routledge Companion to Urban Regeneration, p.330.",
    aurthors: "Thwala, W.D. and Aigbavboa, C.O., ",
    year: "2013",
  },
];

const industry_research = [
  {
    name: "Reports on the Impacts of COVID-19 on the SOUTH AFRICAN Construction Industry",
    aurthors: "Construction Industry Development Board (cidb)",
    year: 2020,
    url: "/cidb.pdf",
  },
];

export { easy_answer, unshuffled_dret, phd_studies, ongoing_studies, masters_studies, journals, books, book_chapters, industry_research };
